(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3588,1368],{

/***/ 35405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16251);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68166);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);






const BadgeWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div `
  position: relative;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const StyledBadge = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme, top, right, color }) => `
  min-width: ${theme.spacing.s16};
  height: ${theme.spacing.s16};
  padding: ${theme.spacing.s0} ${theme.spacing.s4};
  background: ${color ? color : theme.colors.error500};
  border-radius: ${theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? (typeof top === 'number' ? `${top}px` : top) : 0};
  right: ${right ? (typeof right === 'number' ? `${right}px` : right) : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS) `
  text-align: center;
`;
const Badge = (_a) => {
    var { count, offset, overflowCount = 99, showZero = false, color, children } = _a, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(_a, ["count", "offset", "overflowCount", "showZero", "color", "children"]);
    const displayCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
        return count < 0
            ? 0
            : overflowCount && count > overflowCount
                ? `${overflowCount}+`
                : count;
    }, [count, overflowCount]);
    const [top, right] = offset ? offset : [];
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeWrapper, Object.assign({}, rest),
        children,
        (count > 0 || (count === 0 && showZero)) && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, { top: top, right: right, color: color },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCaption, { level: 3, color: "white" }, displayCount)))));
};




/***/ }),

/***/ 56842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68166);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59980);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65290);







const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div `
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => (props.fluid ? '100%' : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth))};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const { children, fluid = false, maxWidth = 1232 } = props, others = (0,tslib__WEBPACK_IMPORTED_MODULE_5__/* .__rest */ ._T)(props, ["children", "fluid", "maxWidth"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({ maxWidth: maxWidth, fluid: fluid, ref: ref }, others), children));
});
Container.displayName = 'Container';




/***/ }),

/***/ 67386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Divider; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84019);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68166);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59802);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65290);







const Divider = (_a) => {
    var { width = '100%', height = '1px', color = 'black', dividerStyle = _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .DividerStyleEnum.solid */ .fd.solid, align, gap, alignContent, spacingContent, children } = _a, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["width", "height", "color", "dividerStyle", "align", "gap", "alignContent", "spacingContent", "children"]);
    const renderSeparator = () => {
        if (!children) {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparator, { width: width, weight: height, dividerStyle: dividerStyle, color: color, align: align }));
        }
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperSeparatorText, { width: width, weight: height, dividerStyle: dividerStyle, color: color, align: align, alignContent: alignContent, spacingContent: spacingContent },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", null, children)));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(WrapperDivider, Object.assign({}, rest, { gap: gap }), renderSeparator()));
};
const WrapperDivider = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ gap }) => [
    _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F,
    `
  --divider-gap: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_5__/* .pixelParse */ .oJ)(gap) || '12px'};
  display: flex;
  padding-top: var(--divider-gap);
  padding-bottom: var(--divider-gap);
`,
]);
const transformAlign = (align) => {
    switch (align) {
        case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.center */ .v2.center:
            return 'margin: 0 auto;';
        case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
            return `
        margin: 0 auto;
        margin-right: 0;
      `;
        default:
            return '';
    }
};
const transformAlignContent = (alignContent) => {
    const css = `{
    display: block;
    content: "";
    border-bottom: 0;
    flex-grow: 1;
    border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  }`;
    switch (alignContent) {
        case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.left */ .v2.left:
            return `
          &:after ${css}
        `;
        case _teko_types_shared__WEBPACK_IMPORTED_MODULE_1__/* .Alignment.right */ .v2.right:
            return `
          &:before ${css}
        `;
        default:
            return `
          &:after, &:before ${css}
        `;
    }
};
const WrapperSeparator = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ width, weight, dividerStyle, color, align, theme, }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${color ? theme.colors[color] || color : '#000000'};
  --divider-border-width: ${weight || '1px'};
  display: flex;
  width: ${width ? width : '100%'};
  border-top: var(--divider-border-width) var(--divider-border-style) var(--divider-color);
  ${transformAlign(align)}
`);
const WrapperSeparatorText = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(({ width, weight, dividerStyle, color = 'black', align, alignContent, spacingContent, theme, }) => `
  --divider-border-style: ${dividerStyle};
  --divider-color: ${theme.colors[color] || color};
  --divider-border-width: ${weight || '1px'};
  --divider-content-spacing: ${spacingContent || '10px'};
  display: flex;
  align-items: center;
  width: ${width ? width : '100%'};
  ${transformAlign(align)}
  ${transformAlignContent(alignContent)}

  > span {
    margin: 0 var(--divider-content-spacing);
    margin-left: ${alignContent === 'left' ? '0' : 'var(--divider-content-spacing)'};
    margin-right: ${alignContent === 'right' ? '0' : 'var(--divider-content-spacing)'};
  }
`);
Divider.displayName = 'Divider';




/***/ }),

/***/ 11005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JX": function() { return /* binding */ Col; },
/* harmony export */   "XE": function() { return /* binding */ floorPercentage; },
/* harmony export */   "e9": function() { return /* binding */ percentage; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67085);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55151);
/* harmony import */ var _constant_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59980);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68166);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31310);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59802);









function parseFlex(flex) {
    if (typeof flex === 'number') {
        return `${flex} ${flex} auto`;
    }
    if (/^\d+(\.\d+)?(px|em|rem|%)$/.test(flex)) {
        return `0 0 ${flex}`;
    }
    return flex;
}
const sizes = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const Col = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const { gutter, wrap } = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_RowContext_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z);
    const { span, order, offset, push, pull, className, children, flex, style } = props, others = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(props, ["span", "order", "offset", "push", "pull", "className", "children", "flex", "style"]);
    const prefixCls = 'teko-col';
    let sizeClassObj = {};
    sizes.forEach((size) => {
        let sizeProps = {};
        const propSize = props[size];
        if (typeof propSize === 'number') {
            sizeProps.span = propSize;
        }
        else if (typeof propSize === 'object') {
            sizeProps = propSize || {};
        }
        sizeClassObj = Object.assign(Object.assign({}, sizeClassObj), { [`${prefixCls}-${size}-${sizeProps.span}`]: sizeProps.span !== undefined, [`${prefixCls}-${size}-order-${sizeProps.order}`]: sizeProps.order || sizeProps.order === 0, [`${prefixCls}-${size}-offset-${sizeProps.offset}`]: sizeProps.offset || sizeProps.offset === 0, [`${prefixCls}-${size}-push-${sizeProps.push}`]: sizeProps.push || sizeProps.push === 0, [`${prefixCls}-${size}-pull-${sizeProps.pull}`]: sizeProps.pull || sizeProps.pull === 0 });
    });
    const classes = classnames__WEBPACK_IMPORTED_MODULE_1___default()(prefixCls, {
        [`${prefixCls}-${span}`]: span !== undefined,
        [`${prefixCls}-order-${order}`]: order,
        [`${prefixCls}-offset-${offset}`]: offset,
        [`${prefixCls}-push-${push}`]: push,
        [`${prefixCls}-pull-${pull}`]: pull,
    }, className, sizeClassObj);
    let mergedStyle = Object.assign({}, style);
    if (gutter) {
        mergedStyle = Object.assign(Object.assign({}, (gutter[0] && gutter[0] > 0
            ? {
                paddingLeft: gutter[0] / 2,
                paddingRight: gutter[0] / 2,
            }
            : {})), mergedStyle);
    }
    if (flex) {
        mergedStyle.flex = parseFlex(flex);
        if (flex === 'auto' && wrap === false && !mergedStyle.minWidth) {
            mergedStyle.minWidth = 0;
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, Object.assign({}, others, { style: mergedStyle, className: classes, ref: ref }), children));
});
Col.displayName = 'Col';
const floorPercentage = (percent) => {
    return Math.floor(percent * 100) / 100;
};
const percentage = (x, y) => {
    return floorPercentage((x / y) * 100) + '%';
};
const loopGridColumn = (_class = '') => {
    let _css = `
    &.teko-col${_class}-0 {
      display: none;
    }
    &.teko-col-push-0 {
      left: auto;
    }
    &.teko-col-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-push-0 {
      left: auto;
    }
    &.teko-col${_class}-pull-0 {
      right: auto;
    }
    &.teko-col${_class}-offset-0 {
      margin-left: 0;
    }
    &.teko-col${_class}-order-0 {
      order: 0;
    }
  `;
    for (let i = 1; i <= 24; i++) {
        _css += `
      &.teko-col${_class}-${i} {
        display: block;
        flex: 0 0 ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
        max-width: ${_class === '-lg'
            ? '84px'
            : ['-xl', '-xxl'].includes(_class)
                ? '104px'
                : percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-push-${i} {
        left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-pull-${i} {
        right: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-offset-${i} {
        margin-left: ${percentage(i, _constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .GRID_COLUMNS */ .s)};
      }
      &.teko-col${_class}-order-${i} {
        order: ${i};
      }
    `;
    }
    return _css;
};
const makeGrid = _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv `
  ${loopGridColumn()}
  ${loopGridColumn('-xs')}
  ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d)
    .map((label) => label !== 'xs'
    ? `
    @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d[label]}) {
      ${loopGridColumn(`-${label}`)}
    }
  `
    : '')
    .join('')}
`;
const flexStyle = (flex) => {
    if (!flex)
        return;
    return `
    flex: ${parseFlex(flex)};
    ${typeof flex === 'string' ? `max-width: ${flex} !important;` : ''}
  `;
};
const makeFlexStyles = (props) => {
    var _a;
    return _emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv `
    ${typeof props.xs === 'object' && ((_a = props.xs) === null || _a === void 0 ? void 0 : _a.flex) !== undefined
        ? flexStyle(props.xs.flex)
        : ''}
    ${Object.keys(_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d)
        .map((label) => {
        var _a, _b;
        return ((_a = props[label]) === null || _a === void 0 ? void 0 : _a.flex) && label !== 'xs'
            ? `
      @media (min-width: ${_constant_es_js__WEBPACK_IMPORTED_MODULE_5__/* .BREAK_POINTS */ .d[label]}) {
        ${flexStyle((_b = props[label]) === null || _b === void 0 ? void 0 : _b.flex)};
      }
    `
            : '';
    })
        .join('')}
  `;
};
const StyledCol = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(`
  &.teko-col {
    position: relative;
    max-width: 100%;
    // Prevent columns from collapsing when empty
    min-height: 1px;
  }`, _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_7__/* .CommonStyles */ .F, makeGrid, makeFlexStyles);




/***/ }),

/***/ 51296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../.yarn/cache/tslib-npm-2.3.1-0e21e18015-de17a98d46.zip/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(91806);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/cache/classnames-npm-2.3.1-f2ae0a8d3c-14db8889d5.zip/node_modules/classnames/index.js
var classnames = __webpack_require__(67085);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/RowContext.es.js
var RowContext_es = __webpack_require__(55151);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/util.es.js
const responsiveArray = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs',
];
const responsiveMap = {
    xs: '(max-width: 575px)',
    sm: '(min-width: 576px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1440px)',
    xxl: '(min-width: 1600px)',
};
const subscribers = new Map();
let subUid = -1;
let screens = {};
const responsiveObserve = {
    matchHandlers: {},
    dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach((func) => func(screens));
        return subscribers.size >= 1;
    },
    subscribe(func) {
        if (!subscribers.size)
            this.register();
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
    },
    unsubscribe(token) {
        subscribers.delete(token);
        if (!subscribers.size)
            this.unregister();
    },
    unregister() {
        Object.keys(responsiveMap).forEach((screen) => {
            const matchMediaQuery = responsiveMap[screen];
            const handler = this.matchHandlers[matchMediaQuery];
            handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
    },
    register() {
        Object.keys(responsiveMap).forEach((screen) => {
            const matchMediaQuery = responsiveMap[screen];
            const listener = ({ matches }) => {
                this.dispatch(Object.assign(Object.assign({}, screens), { [screen]: matches }));
            };
            const mql = window.matchMedia(matchMediaQuery);
            mql.addListener(listener);
            this.matchHandlers[matchMediaQuery] = {
                mql,
                listener,
            };
            listener(mql);
        });
    },
};
var ResponsiveObserve = responsiveObserve;



// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/constant.es.js
var constant_es = __webpack_require__(59980);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/BaseProps/index.es.js
var index_es = __webpack_require__(68166);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/Row.es.js









const Row = react.forwardRef((props, ref) => {
    const { justify, align, className, style, children, gutter = 0, wrap } = props, others = (0,tslib_es6/* __rest */._T)(props, ["justify", "align", "className", "style", "children", "gutter", "wrap"]);
    const [screens, setScreens] = react.useState({
        xs: true,
        sm: true,
        md: true,
        lg: true,
        xl: true,
        xxl: true,
    });
    const gutterRef = react.useRef(gutter);
    react.useEffect(() => {
        const token = ResponsiveObserve.subscribe((screen) => {
            const currentGutter = gutterRef.current || 0;
            if ((!Array.isArray(currentGutter) &&
                typeof currentGutter === 'object') ||
                (Array.isArray(currentGutter) &&
                    (typeof currentGutter[0] === 'object' ||
                        typeof currentGutter[1] === 'object'))) {
                setScreens(screen);
            }
        });
        return () => ResponsiveObserve.unsubscribe(token);
    }, []);
    const getGutter = () => {
        const results = [0, 0];
        const normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
        normalizedGutter.forEach((g, index) => {
            if (typeof g === 'object') {
                for (let i = 0; i < responsiveArray.length; i++) {
                    const breakpoint = responsiveArray[i];
                    if (screens[breakpoint] && g[breakpoint] !== undefined) {
                        results[index] = g[breakpoint];
                        break;
                    }
                }
            }
            else {
                results[index] = g || 0;
            }
        });
        return results;
    };
    const prefixCls = 'teko-row';
    const gutters = getGutter();
    const classes = classnames_default()(prefixCls, {
        [`${prefixCls}-no-wrap`]: wrap === false,
        [`${prefixCls}-${justify}`]: justify,
        [`${prefixCls}-${align}`]: align,
    }, className);
    const rowStyle = Object.assign(Object.assign(Object.assign({}, (gutters[0] && gutters[0] > 0
        ? {
            marginLeft: gutters[0] / -2,
            marginRight: gutters[0] / -2,
        }
        : {})), (gutters[1] && gutter[1] > 0
        ? {
            rowGap: gutters[1],
        }
        : {})), style);
    return (react.createElement(RowContext_es/* default.Provider */.Z.Provider, { value: { gutter: gutters, wrap } },
        react.createElement(StyledRow, Object.assign({}, others, { className: classes, style: rowStyle, ref: ref }), children)));
});
Row.displayName = 'Row';
const StyledRow = emotion_styled_browser_esm/* default.div */.Z.div `
  &.teko-row {
    display: flex;
    flex-flow: row wrap;
  }
  @media (min-width: ${constant_es/* BREAK_POINTS.lg */.d.lg}) {
    &.teko-row {
      justify-content: center;
    }
  }
  &.teko-row:before,
  &.teko-row:after {
    display: flex;
  }

  // No wrap of flex
  &.teko-row-no-wrap {
    flex-wrap: nowrap;
  }

  &.teko-row-start {
    justify-content: flex-start;
  }

  &.teko-row-center {
    justify-content: center;
  }

  &.teko-row-end {
    justify-content: flex-end;
  }

  &.teko-row-space-between {
    justify-content: space-between;
  }

  &.teko-row-space-around {
    justify-content: space-around;
  }

  &.teko-row-top {
    align-items: flex-start;
  }

  &.teko-row-middle {
    align-items: center;
  }

  &.teko-row-bottom {
    align-items: flex-end;
  }
  ${index_es/* CommonStyles */.F}
`;




/***/ }),

/***/ 55151:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RowContext$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const RowContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var RowContext$1 = RowContext;




/***/ }),

/***/ 59980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ BREAK_POINTS; },
/* harmony export */   "s": function() { return /* binding */ GRID_COLUMNS; }
/* harmony export */ });
const BREAK_POINTS = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1440px',
    xxl: '1600px',
};
const GRID_COLUMNS = 12;




/***/ }),

/***/ 92511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65290);





const fallbackImage = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNjAiIGhlaWdodD0iMjYwIiB2aWV3Qm94PSIwIDAgMjYwIDI2MCI+CiAgICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGZpbGw9IiNGNkY2RjYiIGQ9Ik0wIDBoMjYwdjI2MEgweiIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMDQgMTA0aDU0djU0aC01NHoiLz4KICAgICAgICA8cGF0aCBmaWxsPSIjQjRCNEI0IiBkPSJNMTUxLjI1IDEwNi4yNWE0LjUgNC41IDAgMCAxIDQuNSA0LjV2NDAuNWE0LjUgNC41IDAgMCAxLTQuNSA0LjVoLTQwLjVhNC41IDQuNSAwIDAgMS00LjUtNC41di00MC41YTQuNSA0LjUgMCAwIDEgNC41LTQuNWg0MC41em0tMTMuNSAxOGwtOSAxMy41TDEyMiAxMzFsLTYuNzUgMTEuMjVoMzEuNWwtOS0xOHptLTEyLjM3NS02Ljc1YTMuMzc1IDMuMzc1IDAgMSAwIDAgNi43NSAzLjM3NSAzLjM3NSAwIDAgMCAwLTYuNzV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=';
const Image = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const { src, height, objectFit, width, alt, onClick, borderRadius, thumbnail, hover, decoding = 'async', className, lazy = true, pngSrc } = props, others = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(props, ["src", "height", "objectFit", "width", "alt", "onClick", "borderRadius", "thumbnail", "hover", "decoding", "className", "lazy", "pngSrc"]);
    const imgElement = (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, Object.assign({ ref: ref, objectFit: objectFit, src: src || fallbackImage, loading: lazy ? 'lazy' : 'eager', hover: hover, height: height, decoding: decoding, alt: alt }, others)));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Container, { height: height, width: width, onClick: onClick, borderRadius: borderRadius, thumbnail: thumbnail, className: className }, pngSrc ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("picture", null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: src, type: 'image/webp' }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("source", { srcSet: pngSrc, type: 'image/png' }),
        imgElement)) : (imgElement)));
});
Image.displayName = 'Image';
const Container = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ onClick, borderRadius, height, thumbnail, width }) => `
  position: relative;
  display: inline-block;
  overflow: hidden;
  ${onClick ? 'cursor: pointer;' : ''}
  ${borderRadius ? `border-radius: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(borderRadius)};` : ''}
  ${height ? `height: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)};` : ''}
  ${width ? `width: ${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(width)};` : ''}
  ${thumbnail
    ? ` background-image: ${`url("${thumbnail}")`};
     background-size: cover;`
    : ''}
`);
const StyledImage = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].img */ .Z.img(({ hover, height, objectFit }) => `
  width: 100%;
  height: ${height ? `${(0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(height)}` : 'auto'};
  ${objectFit ? `object-fit: ${objectFit}` : ''};
  transition: transform 0.3s;
  &:hover {
    ${hover === 'zoom' ? 'transform: scale(1.05)' : ''};
  };
`);




/***/ }),

/***/ 9995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ ChecklistOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const ChecklistOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M7.88334 3.75C7.88334 3.33579 8.21913 3 8.63334 3H15.4289C15.8431 3 16.1789 3.33579 16.1789 3.75V3.97071H17.3118C18.8306 3.97071 20.0618 5.20193 20.0618 6.72071V18.2533C20.0618 19.7721 18.8306 21.0033 17.3118 21.0033H6.75C5.23122 21.0033 4 19.7721 4 18.2533V6.72071C4 5.20193 5.23122 3.97071 6.75 3.97071H7.88334V3.75ZM16.1789 7.63315V5.47071H17.3118C18.0022 5.47071 18.5618 6.03036 18.5618 6.72071V18.2533C18.5618 18.9437 18.0022 19.5033 17.3118 19.5033H6.75C6.05964 19.5033 5.5 18.9437 5.5 18.2533V6.72071C5.5 6.03036 6.05964 5.47071 6.75 5.47071H7.88334V7.63315C7.88334 8.04736 8.21913 8.38315 8.63334 8.38315H10.3322C10.7464 8.38315 11.0822 8.04736 11.0822 7.63315C11.0822 7.42585 11.3581 7.00247 12.0311 7.00247C12.7041 7.00247 12.98 7.42585 12.98 7.63315C12.98 8.04736 13.3158 8.38315 13.73 8.38315H15.4289C15.8431 8.38315 16.1789 8.04736 16.1789 7.63315ZM9.38334 4.5V6.88315H9.73243C10.0999 6.01694 11.0835 5.50247 12.0311 5.50247C12.9787 5.50247 13.9623 6.01694 14.3298 6.88315H14.6789V4.5H9.38334ZM15.6523 12.0465C15.9452 11.7536 15.9452 11.2788 15.6523 10.9859C15.3594 10.693 14.8845 10.693 14.5916 10.9859L11.3282 14.2493L10.1341 13.0552C9.84125 12.7623 9.36638 12.7623 9.07348 13.0552C8.78059 13.3481 8.78059 13.8229 9.07348 14.1158L10.7979 15.8403C10.9386 15.9809 11.1293 16.0599 11.3282 16.0599C11.5271 16.0599 11.7179 15.9809 11.8586 15.8403L15.6523 12.0465Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 50659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ PromoOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80711);


const PromoOutlined = (props) => {
    return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M6.19499 3C5.99608 3 5.80532 3.07902 5.66466 3.21967L3.21967 5.66466C3.07902 5.80532 3 5.99608 3 6.19499V11.085C3 11.2839 3.07902 11.4747 3.21967 11.6153L12.3884 20.784C12.6813 21.0769 13.1562 21.0769 13.4491 20.784L17.1166 17.1166L20.784 13.4491C21.0769 13.1562 21.0769 12.6813 20.784 12.3884L11.6153 3.21967C11.4747 3.07902 11.2839 3 11.085 3H6.19499ZM4.5 6.50565L6.50565 4.5H10.7743L19.1931 12.9187L16.0559 16.0559L12.9187 19.1931L4.5 10.7743V6.50565ZM7.86186 9.2514C7.86186 8.65286 8.34707 8.16765 8.94561 8.16765C9.54415 8.16765 10.0294 8.65286 10.0294 9.2514C10.0294 9.84994 9.54415 10.3351 8.94561 10.3351C8.34707 10.3351 7.86186 9.84994 7.86186 9.2514ZM8.94561 6.66765C7.51865 6.66765 6.36186 7.82444 6.36186 9.2514C6.36186 10.6784 7.51865 11.8351 8.94561 11.8351C10.3726 11.8351 11.5294 10.6784 11.5294 9.2514C11.5294 7.82444 10.3726 6.66765 8.94561 6.66765ZM11.3097 12.9996C11.0168 12.7067 10.5419 12.7067 10.249 12.9996C9.95613 13.2925 9.95613 13.7674 10.249 14.0603L12.3884 16.1996C12.6813 16.4925 13.1562 16.4925 13.449 16.1996C13.7419 15.9067 13.7419 15.4319 13.449 15.139L11.3097 12.9996ZM12.694 10.5545C12.9869 10.2616 13.4618 10.2616 13.7547 10.5545L15.8941 12.6939C16.187 12.9868 16.187 13.4616 15.8941 13.7545C15.6012 14.0474 15.1263 14.0474 14.8334 13.7545L12.694 11.6151C12.4011 11.3223 12.4011 10.8474 12.694 10.5545Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};




/***/ }),

/***/ 29574:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CartNumberTracking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);


const CartNumberTracking = ({ totalItems, }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "shoppingCartProductNumber", style: { display: 'none' } }, totalItems));
};




/***/ }),

/***/ 33153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91590);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a `
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
    var { targetPath, children, targetType = '_self', passHref = false } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["targetPath", "children", "targetType", "passHref"]);
    if (!targetPath)
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    const a11yProps = {};
    if (typeof children !== 'string') {
        a11yProps['aria-label'] = 'Image';
    }
    if (targetPath.startsWith('http') || targetPath.startsWith('/'))
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, Object.assign({ target: targetType, href: targetPath }, a11yProps, props), children));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], { href: passHref ? targetPath : `/search?${targetPath}` },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, Object.assign({ target: targetType, href: passHref ? targetPath : `/search?${targetPath}` }, a11yProps, props), children)));
};




/***/ }),

/***/ 62832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ListTile; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);




const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div((props) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: ${props.selected ? '#f5f5f5' : '#fff'};
    padding: 0.6rem;
    cursor: ${props.onClick ? 'pointer' : ''};
    &:hover {
      background-color: ${props.type !== 'search-suggestion' && '#f5f5f5'};
    }
  `);
const Title = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(props) => props.numberOfLine};
  overflow: hidden;
  margin: 0 0.6rem;
  flex: 1;
`;
const ListTile = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { leading, title, trailing, numberOfLine = 1, onClick, onMouseEnter, type, selected = false } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["leading", "title", "trailing", "numberOfLine", "onClick", "onMouseEnter", "type", "selected"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({ ref: ref, selected: selected, onMouseEnter: onMouseEnter }, props, { onClick: onClick, type: type }),
        leading,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, { numberOfLine: numberOfLine }, title),
        trailing));
});
ListTile.displayName = 'ListTile';




/***/ }),

/***/ 82175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68247);




const Logo = (_a) => {
    var { variant = 'full', logoFull, logoLite, alt } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(_a, ["variant", "logoFull", "logoLite", "alt"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .E, Object.assign({ src: variant === 'full' ? logoFull : logoLite, alt: alt }, props)));
};




/***/ }),

/***/ 98274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Messenger; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/assets/images/live-chat-full.es.js
var messengerFull = "https://shopfront-cdn.tekoapis.com/static/3ad4c9a97ab98ff3.png";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/assets/images/live-chat.es.js
var messenger = "https://shopfront-cdn.tekoapis.com/static/a8e347d31db4d701.png";



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/Messenger/Messenger.es.js





const Wrapper = styled_es/* styled.a */.z.a `
  z-index: 1030;
  position: fixed;
  right: 2.5rem;
  bottom: 5.6rem;
  cursor: pointer;
  @media (min-width: 1440px) {
    .fb-chat-full {
      display: block;
    }
    .fb-chat {
      display: none;
    }
  }
  @media (max-width: 1440px) {
    .fb-chat-full {
      display: none;
    }
    .fb-chat {
      display: block;
    }
  }
  @media print {
    display: none;
  }
`;
const Messenger = ({ url, }) => {
    return (react.createElement(Wrapper, { href: url, target: "_blank", rel: "noreferrer", "data-track-content": true, "data-content-region-name": "quickAction", "data-content-name": "fbMessengerIcon" },
        react.createElement("img", { className: "fb-chat-full", src: messengerFull, alt: "fb-chat" }),
        react.createElement("img", { className: "fb-chat", src: messenger, alt: "fb-chat" })));
};




/***/ }),

/***/ 32715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/i18n.es.js
var i18n_es = __webpack_require__(8756);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/Container/Container.es.js
var Container_es = __webpack_require__(1134);
// EXTERNAL MODULE: ../../.yarn/__virtual__/reflexbox-virtual-95900ce272/0/cache/reflexbox-npm-4.0.6-201af1058c-b532551c8b.zip/node_modules/reflexbox/dist/index.js
var dist = __webpack_require__(98522);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(75068);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Layout/Footer/components/FooterBlock/FooterBlock.es.js



const ColumnTitle = styled_es/* styled.div */.z.div `
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 10px;
`;
const StyledButton = (0,styled_es/* styled */.z)(Button_es/* Button */.z)((props) => `
  font-size: 12px;
  color: #333;
  padding-left: 0px;
  text-align: left;
  text-decoration: none;
  padding-bottom: 0px;
  max-width: ${!props.block ? '72px' : 'initial'};
  justify-content: flex-start;
`);
const ContactInnerLine = styled_es/* styled.div */.z.div `
  font-size: 12px;
  width: 100%;
  a {
    text-decoration: none;
  }
  span {
    line-height: 1.5rem;
  }
  padding-top: 0.365rem;
  padding-right: 0.75rem;
`;
const StyledImg = styled_es/* styled.img */.z.img((props) => `
  ${props.isLogo ? 'max-width: 180px;' : ''}
  width: 100%;
`);
const FooterBlock = ({ title, links = [], emails = [], phones = [], flexDir = 'row', image, isLogoImage, btnBlock = true, }) => {
    return (react.createElement(react.Fragment, null,
        title && react.createElement(ColumnTitle, { key: title }, title),
        emails.map((email, index) => {
            return (react.createElement(ContactInnerLine, { key: `email-${index}`, dangerouslySetInnerHTML: {
                    __html: `${email.children} <a href='mailto:${email.address}'>${email.address}</a>`,
                } }));
        }),
        phones.map((phone, index) => {
            return (react.createElement(ContactInnerLine, { key: `email-${index}`, dangerouslySetInnerHTML: {
                    __html: `${phone.children}<a href='tel:${phone.number.replace(/\./g, '')}'}>${phone.number}</a>`,
                } }));
        }),
        links.map((link, index) => {
            return (react.createElement(StyledButton, Object.assign({ tag: "a", block: btnBlock, link: true, key: `link-${index}`, flexDirection: flexDir }, link)));
        }),
        image && react.createElement(StyledImg, { isLogo: !!isLogoImage, src: image, alt: "" })));
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Layout/Footer/Footer.es.js






const FooterWrapper = styled_es/* styled.div */.z.div(({ theme }) => `
  @media print {
    display: none;
  }
  border-top: solid 3px ${theme.brand.primary};
  position: relative;
`);
const Wrapper = styled_es/* styled.nav */.z.nav(({ theme }) => `
  background-color: ${theme.colors.white};
  padding: 1rem 0;
`);
const StyledContainer = (0,styled_es/* styled */.z)(Container_es/* Container */.W) `
  display: flex;
  margin-bottom: 10px;
`;
const ColumnInnerLine = styled_es/* styled.div */.z.div `
  font-size: 12px;
  width: 100%;
  padding-right: 8px;
  a {
    color: #333;
    text-decoration: none;
    display: flex;
    align-items: center;
  }
  span {
    line-height: 1.5rem;
  }
`;
const StyledWrapper = (0,styled_es/* styled */.z)(Wrapper)(({ customBottomColor, theme }) => `
  background-color: ${(customBottomColor && theme.colors[customBottomColor]) || '#e9edf2'};
  margin-top: -10px;
  padding-top: 30px;
  padding-bottom: 25px;
`);
const CompanyName = styled_es/* styled.div */.z.div `
  font-size: 14px;
  text-transform: uppercase;
  font-weight: bold;
  margin-bottom: 15px;
`;
const BranchName = styled_es/* styled.span */.z.span `
  font-size: 12px;
  font-weight: bold;
`;
const Footer_es_StyledImg = styled_es/* styled.img */.z.img `
  width: 100%;
  max-width: 160px;
`;
const StyledLink = styled_es/* styled.a */.z.a `
  display: block;
  &:not(:first-child) {
    margin-top: 0.5rem;
  }
`;
const StyledDMCA = styled_es/* styled.div */.z.div `
  margin-top: 0.5rem;
  img {
    width: 100%;
    max-width: 100px;
  }
`;
const Description = styled_es/* styled.p */.z.p `
  font-size: 0.75rem;
  text-align: center;
  margin: 0;
`;
const getResponsiveWidth = (col) => {
    switch (col) {
        case 2:
            return [1 / 2, 1 / 2, 1 / 2, 1 / 2];
        case 3:
            return [1 / 2, 1 / 2, 1 / 2, 1 / 3];
        case 4:
            return [1 / 2, 1 / 2, 1 / 2, 1 / 4];
        default:
            return [1 / 2, 1 / 3, 1 / 3, 1 / 5];
    }
};
const Footer = ({ footer, customBottomColor, baseUrl, }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    return (react.createElement(FooterWrapper, null,
        (footer.bankList ||
            footer.supportAndPolicy ||
            footer.paymentMethods) && (react.createElement(Wrapper, null,
            footer.supportAndPolicy && (react.createElement(StyledContainer, null,
                react.createElement(dist/* Flex */.kC, { flexWrap: "wrap", justifyContent: "space-between", width: '100%' }, footer.supportAndPolicy.map((column, index) => {
                    return (react.createElement(dist/* Box */.xu, { width: getResponsiveWidth(footer.supportAndPolicy.length), key: index },
                        react.createElement(FooterBlock, { title: column.title, links: column.links, emails: column.emails, phones: column.phones, image: column.image, isLogoImage: true })));
                })))),
            react.createElement(StyledContainer, null,
                react.createElement(dist/* Flex */.kC, { flexWrap: "wrap" },
                    footer.paymentMethods && (react.createElement(dist/* Box */.xu, { width: [1, 1, '40%'] },
                        react.createElement(FooterBlock, { title: footer.paymentMethods.title, links: footer.paymentMethods.links, flexDir: "column", btnBlock: false }))),
                    footer.bankList && (react.createElement(dist/* Box */.xu, { width: [1, 1, '60%'] },
                        react.createElement(FooterBlock, { title: (0,i18n_es.t)('Danh sách các ngân hàng thanh toán online'), image: footer.bankList.imgSrc }))))))),
        footer.bottom && (react.createElement(StyledWrapper, { customBottomColor: customBottomColor },
            react.createElement(StyledContainer, null,
                react.createElement(dist/* Flex */.kC, { flexWrap: "wrap", width: "100%" },
                    react.createElement(dist/* Box */.xu, { width: [1, '50%', '35%', '40%'] }, ((_a = footer.bottom) === null || _a === void 0 ? void 0 : _a.company) && (react.createElement(react.Fragment, null,
                        react.createElement(CompanyName, null, (_b = footer.bottom) === null || _b === void 0 ? void 0 : _b.company.name),
                        react.createElement(ColumnInnerLine, { dangerouslySetInnerHTML: {
                                __html: (_c = footer.bottom) === null || _c === void 0 ? void 0 : _c.company.detail,
                            } })))),
                    react.createElement(dist/* Box */.xu, { width: [1, '50%', '35%', '40%'] },
                        footer.bottom.address &&
                            footer.bottom.address.map((addressDetail) => {
                                return (react.createElement("div", { key: addressDetail.branchName },
                                    react.createElement(BranchName, null, addressDetail.branchName),
                                    ":",
                                    react.createElement(ColumnInnerLine, null, addressDetail.branchAddress)));
                            }),
                        footer.bottom.phone && footer.bottom.email && (react.createElement(ColumnInnerLine, null, `${(0,i18n_es.t)('Số điện thoại')}: ${footer.bottom.phone} - Email: ${footer.bottom.email} `))),
                    react.createElement(dist/* Box */.xu, { width: [1, '100%', '30%', '20%'] },
                        !!((_e = (_d = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _d === void 0 ? void 0 : _d.registeredLogo) === null || _e === void 0 ? void 0 : _e.logo) && (react.createElement(StyledLink, { href: (_f = footer.bottom.registeredLogo) === null || _f === void 0 ? void 0 : _f.link, rel: "noreferrer noopener", target: "_blank" },
                            react.createElement(Footer_es_StyledImg, { src: footer.bottom.registeredLogo.logo, alt: "registered logo" }))),
                        !!((_h = (_g = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _g === void 0 ? void 0 : _g.verifiedLogo) === null || _h === void 0 ? void 0 : _h.logo) && (react.createElement(StyledLink, { href: (_j = footer.bottom.verifiedLogo) === null || _j === void 0 ? void 0 : _j.link, rel: "noreferrer noopener", target: "_blank" },
                            react.createElement(Footer_es_StyledImg, { src: footer.bottom.verifiedLogo.logo, alt: "verified logo" }))),
                        ((_k = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _k === void 0 ? void 0 : _k.dmcaBadgeLink) && ((_l = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _l === void 0 ? void 0 : _l.dmcaId) && (react.createElement(StyledDMCA, null,
                            react.createElement("a", { href: `//www.dmca.com/Protection/Status.aspx?ID=${(_m = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _m === void 0 ? void 0 : _m.dmcaId}&refurl=${baseUrl}`, title: "DMCA.com Protection Status", className: "dmca-badge" },
                                react.createElement("img", { src: `${(_o = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _o === void 0 ? void 0 : _o.dmcaBadgeLink}?ID=${(_p = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _p === void 0 ? void 0 : _p.dmcaId}`, alt: "DMCA.com Protection Status" }))))),
                    react.createElement(dist/* Box */.xu, { width: [1] }, ((_q = footer === null || footer === void 0 ? void 0 : footer.bottom) === null || _q === void 0 ? void 0 : _q.description) && (react.createElement(Description, { dangerouslySetInnerHTML: {
                            __html: footer.bottom.description,
                        } })))))))));
};




/***/ }),

/***/ 27893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);




const getColor = (props) => {
    const { color, theme } = props;
    return ((color && (theme.brand[color] || theme.colors[color])) ||
        color ||
        theme.colors.dark);
};
const StyledText = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, (props) => {
    return `
    color: ${getColor(props)};
    font-weight: ${props.fontWeight || '400'};
    font-size: ${props.fontSize || 14}px;
    ${props.lineHeight ? ` line-height: ${props.lineHeight}px;` : ''}
    text-align: ${props.textAlign || 'left'};
    overflow: hidden;
    ${props.maxLines
        ? `text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${props.maxLines};`
        : ''}
    ${props.textTransform
        ? `
      text-transform: ${props.textTransform};
    `
        : ''}
  `;
});
const Text = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledText, Object.assign({}, props));
};




/***/ }),

/***/ 1368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91806);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61089);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92511);
/* harmony import */ var _helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82201);





const EnhancedImage = (props) => {
    const { src, googleImageParams, link, tracking } = props, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__rest */ ._T)(props, ["src", "googleImageParams", "link", "tracking"]);
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .CustomLink */ .x, Object.assign({}, link, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .E, Object.assign({}, tracking, rest, { src: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getImageUrlFromGoogleUserContent */ .N)(src, Object.assign({ format: 'webp' }, googleImageParams)), pngSrc: (0,_helpers_image_es_js__WEBPACK_IMPORTED_MODULE_4__/* .getImageUrlFromGoogleUserContent */ .N)(src, Object.assign({ format: 'png' }, googleImageParams)) }), void 0) }), void 0));
};




/***/ }),

/***/ 12624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ MegaMenu; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(61089);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(16251);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/helpers/megaMenu.es.js
var megaMenu_es = __webpack_require__(65913);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/EnhancedImage/EnhancedImage.es.js
var EnhancedImage_es = __webpack_require__(1368);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/MegaMenu/MenuPanel.es.js






const MenuPanel = ({ menu, className, type, }) => {
    var _a, _b;
    const bannerWidth = '14.625rem';
    if (!menu || (!((_a = menu.banner) === null || _a === void 0 ? void 0 : _a.src) && !menu.children.length))
        return null;
    const bannerSrc = (_b = menu.banner) === null || _b === void 0 ? void 0 : _b.src;
    const getMenuColumns = () => {
        let totalCols = 6;
        if (type === 'vertical')
            totalCols--;
        if (bannerSrc)
            totalCols--;
        return totalCols;
    };
    const newMenu = (0,megaMenu_es/* convertMegaMenu */.R)(menu, getMenuColumns());
    const col = (item) => {
        return item.map((it, index) => ((0,jsx_runtime.jsxs)(MenuLv2, { children: [(0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, Object.assign({}, it.link, { children: (0,jsx_runtime.jsx)(index_es/* SubTitle */.DK, Object.assign({ level: 1, line: 1, color: "primary500", marginBottom: "s8" }, { children: it.name }), void 0) }), void 0), it.children.map((subItem, index) => ((0,react.createElement)(CustomLink_es/* CustomLink */.x, Object.assign({}, subItem.link, { key: index }),
                    (0,jsx_runtime.jsx)(Text, { children: subItem.name }, void 0))))] }, it.name + `-${index}`)));
    };
    return ((0,jsx_runtime.jsxs)(MenuPanelWrapper, Object.assign({ className: className }, { children: [(0,jsx_runtime.jsx)(MenuItemsWrapper, { children: newMenu.map((menu, index) => ((0,jsx_runtime.jsx)(Column, { children: col(menu.column) }, index))) }, void 0), bannerSrc && ((0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, Object.assign({}, menu.banner.link, { children: (0,jsx_runtime.jsx)(EnhancedImage_es/* EnhancedImage */.N, { src: bannerSrc, width: bannerWidth, height: "100%", googleImageParams: {
                        width: 400,
                    } }, void 0) }), void 0))] }), void 0));
};
const Text = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
  color: ${theme.colors.textPrimary};
  margin-bottom: 4px;
  &:hover {
    color: ${theme.colors.primary500};
  }
`);
const MenuPanelWrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
  background-color: ${theme.colors.white};
  display: flex;
`);
const MenuItemsWrapper = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
  display: flex;
  flex: 1;
  padding: ${theme.spacing.s12};
`);
const MenuLv2 = emotion_styled_browser_esm/* default.div */.Z.div `
  margin-bottom: 1.5rem;
`;
const Column = emotion_styled_browser_esm/* default.div */.Z.div `
  width: 25%;
  padding: 0 8px;
`;



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js






const MegaMenu = ({ type, align = 'left', menuItems, }) => {
    const [activeMenu, setActiveMenu] = (0,react.useState)(undefined);
    const verticalMenuWidth = '12.375rem';
    const horizontalMenuHeight = '3rem';
    const megaMenuHeight = '28.5rem';
    if (!menuItems.length)
        return null;
    const rennderVerticalMegaMenu = () => {
        return ((0,jsx_runtime.jsxs)(MegaMenuWrapper, Object.assign({ onMouseLeave: () => {
                setActiveMenu(undefined);
            } }, { children: [(0,jsx_runtime.jsx)(VerticalMegaMenu, Object.assign({ className: activeMenu ? 'active' : '', width: verticalMenuWidth, height: megaMenuHeight }, { children: menuItems.slice(0, 14).map((item, index) => ((0,react.createElement)(CustomLink_es/* CustomLink */.x, Object.assign({}, item.link, { key: index }),
                        (0,jsx_runtime.jsxs)(VerticalMenuItem, Object.assign({ onMouseEnter: () => {
                                setActiveMenu(item);
                            } }, { children: [(0,jsx_runtime.jsx)(VerticalMenuItemImageMegaMenuWrapper, { children: (0,jsx_runtime.jsx)(EnhancedImage_es/* EnhancedImage */.N, { src: item.icon }, void 0) }, void 0), (0,jsx_runtime.jsx)(index_es/* Caption */.YS, Object.assign({ level: 2, line: 1, style: { flex: 1 } }, { children: item.name }), void 0)] }), void 0)))) }), void 0), (0,jsx_runtime.jsx)(VerticalMenuPanel, { className: activeMenu ? 'active' : '', type: type, verticalMenuWidth: verticalMenuWidth, menu: activeMenu }, void 0)] }), void 0));
    };
    const renderHorizontalMegaMenu = () => {
        return ((0,jsx_runtime.jsxs)(MegaMenuWrapper, Object.assign({ onMouseLeave: () => {
                setActiveMenu(undefined);
            } }, { children: [(0,jsx_runtime.jsx)(HorizontalMegaMenu, Object.assign({ height: horizontalMenuHeight, align: align }, { children: menuItems.slice(0, 14).map((item, index) => ((0,react.createElement)(CustomLink_es/* CustomLink */.x, Object.assign({}, item.link, { key: index }),
                        (0,jsx_runtime.jsx)(HorizontalMenuItem, Object.assign({ height: horizontalMenuHeight, onMouseEnter: () => {
                                setActiveMenu(item);
                            } }, { children: (0,jsx_runtime.jsx)(index_es/* Body */.uT, Object.assign({ level: 2, line: 1, hoverColor: "primary500" }, { children: item.name }), void 0) }), void 0)))) }), void 0), (0,jsx_runtime.jsx)(HorizontalMenuPanel, { type: type, className: activeMenu ? 'active' : '', horizontalMenuHeight: horizontalMenuHeight, menu: activeMenu }, void 0)] }), void 0));
    };
    if (type === 'vertical')
        return rennderVerticalMegaMenu();
    return renderHorizontalMegaMenu();
};
const MegaMenuWrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  position: relative;
`;
const VerticalMenuPanel = (0,emotion_styled_browser_esm/* default */.Z)(MenuPanel)(({ verticalMenuWidth, theme, }) => `
  position: absolute;
  top: 0;
  width: calc(75rem - ${verticalMenuWidth});
  left: ${verticalMenuWidth};
  min-height: 100%;
  z-index: 980;
  overflow: hidden;
  transition: all 0.2s;
  visibility: hidden;
  opacity: 0;
  border-radius: ${theme.borderRadius.m};
  &.active {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    visibility: visible;
    opacity: 1;
  }
`);
const HorizontalMenuPanel = (0,emotion_styled_browser_esm/* default */.Z)(MenuPanel)(({ horizontalMenuHeight, theme, }) => `
  position: absolute;
  left: 0;
  right: 0;
  top: ${horizontalMenuHeight};
  z-index: 980;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  border-bottom-right-radius: ${theme.borderRadius.m};
  border-bottom-left-radius: ${theme.borderRadius.m};
  &.active {
    visibility: visible;
    opacity: 1;
    filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.05));
  }
`);
const VerticalMegaMenu = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, width, height }) => `
  border-radius: ${theme.borderRadius.m};
  background-color: ${theme.colors.white};
  position: relative;
  overflow: hidden;
  width: ${width};
  height: ${height};
  z-index: 980;
  &.active {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`);
const HorizontalMegaMenu = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, height, align }) => `
  height: ${height};
  background-color: ${theme.colors.white};
  overflow: hidden;
  width: 100%;
  ${align === 'right'
    ? `display: flex;
        justify-content: flex-end;`
    : align === 'space-between'
        ? `display: flex;
        justify-content: space-between;`
        : ''}
`);
const VerticalMenuItem = emotion_styled_browser_esm/* default.div */.Z.div(({ theme }) => `
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: start;
  gap: ${theme.spacing.s8};
  padding: 0 ${theme.spacing.s8};
  border-radius: ${theme.borderRadius.m};
  overflow: hidden;
  &:hover {
    background-color: ${theme.colors.primary50};
    color: ${theme.colors.primary500};
  }
`);
const HorizontalMenuItem = emotion_styled_browser_esm/* default.div */.Z.div(({ theme, height }) => `
  padding: 0 ${theme.spacing.s12};
  height: ${height};
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  float: left;
  position: relative;
  transition: all 0.3s ease;
  color: ${theme.colors.textPrimary};
  &::after {
    content: '';
    height: 2px;
    background-color: ${theme.colors.primary500};
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
    transition: all 0.3s ease;
  }
  &:hover {
    color: ${theme.colors.primary500};
    &::after {
      opacity: 1;
    }
  }
`);
const VerticalMenuItemImageMegaMenuWrapper = emotion_styled_browser_esm/* default.div */.Z.div `
  width: 22px;
  height: 22px;
`;




/***/ }),

/***/ 36074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ TOPBAR_HEIGHT; },
/* harmony export */   "Z": function() { return /* binding */ Topbar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59802);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56842);



const TOPBAR_HEIGHT = 42;
const Topbar = ({ rightMenu = [], leftMenu = [], }) => {
    return ((0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Wrapper, { children: (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledContainer, { children: [(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuWrapper, { children: leftMenu.map((item) => item) }, void 0), (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuWrapper, { children: rightMenu.map((item) => item) }, void 0)] }, void 0) }, void 0));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(({ theme }) => `
  @media print {
    display: none;
  }
  background-color: ${theme.colors.primary500};
  height: ${TOPBAR_HEIGHT}px;
`);
const StyledContainer = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W) `
  display: flex;
  justify-content: space-between;
`;
const MenuWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div `
  display: flex;
  .button-text {
    font-weight: 500;
  }
`;




/***/ }),

/***/ 82201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ constructGoogleImageParams; },
/* harmony export */   "N": function() { return /* binding */ getImageUrlFromGoogleUserContent; }
/* harmony export */ });
const imgAttributeMapping = {
    width: 'w',
    height: 'h',
    webp: 'rw',
    png: 'rp',
    jpg: 'rj',
    stretch: 's',
    crop: 'c',
};
const constructGoogleImageParams = (url, config) => {
    const baseUrl = url.indexOf('=') >= 0 ? url.substring(0, url.indexOf('=')) : url;
    const params = [];
    Object.entries(config).forEach(([key, value]) => {
        if (!value)
            return;
        if (key === 'format') {
            params.push(imgAttributeMapping[value]);
            return;
        }
        if (key === 'size' && value) {
            params.push(`${imgAttributeMapping[key]}0`);
            return;
        }
        if (imgAttributeMapping[key]) {
            if (typeof value === 'boolean') {
                if (value) {
                    params.push(`${imgAttributeMapping[key]}`);
                    return;
                }
                return;
            }
            params.push(`${imgAttributeMapping[key]}${value}`);
        }
    });
    return params.length > 0 ? `${baseUrl}=${params.join('-')}` : url;
};
const getImageUrlFromGoogleUserContent = (imageUrl, config) => {
    if (imageUrl && imageUrl.includes('googleusercontent.com'))
        return constructGoogleImageParams(imageUrl, config);
    return imageUrl;
};




/***/ }),

/***/ 65913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ convertMegaMenu; }
/* harmony export */ });
const convertMegaMenu = (menu, numberCol) => {
    if (numberCol < 1)
        return;
    const newArr = menu.children.map((m) => {
        return {
            len: m.children.length + 1,
            column: [Object.assign({}, m)],
        };
    });
    if (newArr.length <= numberCol)
        return newArr;
    newArr.sort((a, b) => b.len - a.len);
    const result = [...newArr.slice(0, numberCol)];
    let min;
    let k;
    for (let i = numberCol; i < newArr.length; i++) {
        min = result[0].len;
        k = 0;
        for (let j = 0; j < numberCol; j++) {
            if (min > result[j].len) {
                min = result[j].len;
                k = j;
            }
        }
        result[k] = {
            len: result[k].len + newArr[i].len,
            column: [...result[k].column, ...newArr[i].column],
        };
    }
    return result;
};




/***/ }),

/***/ 68247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);



const StyledImage = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.img */ .z.img ``;
const Image = (props) => {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, Object.assign({}, props));
};




/***/ }),

/***/ 67722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ ScrollTopArrow; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11686);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28697);





const ScrollToTopBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div((props) => `
  border-radius: 50%;
  background-color: ${props.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
`);
const ScrollToTopWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ showScroll, position }) => `
  display: ${showScroll ? 'block' : 'none'};
  z-index: 1030;
  position: fixed;
  ${position.bottom ? `bottom: ${position.bottom}rem;` : ''}
  ${position.top ? `top: ${position.top}rem;` : ''}
  ${position.left ? `left: ${position.left}rem;` : ''}
  ${position.right ? `right: ${position.right}rem;` : ''}
  cursor: pointer;
  animation: fadeIn 0.3s;
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 0.5;
    }
  }
`);
const ScrollTopArrow = ({ className, color = '#ffffff', backgroundColor = ' #333333', position = { bottom: 10, right: 3 }, scrollTopRouters, }) => {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const [showScroll, setShowScroll] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const scrollTopTop = () => {
        if (typeof window !== 'undefined')
            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    };
    const checkScrollTop = () => {
        if (typeof window !== 'undefined') {
            if (!showScroll && window.pageYOffset > 700) {
                setShowScroll(true);
            }
            else if (showScroll && window.pageYOffset <= 700) {
                setShowScroll(false);
            }
        }
    };
    if (typeof window !== 'undefined')
        window.addEventListener('scroll', checkScrollTop);
    let hasRouter = false;
    (scrollTopRouters === null || scrollTopRouters === void 0 ? void 0 : scrollTopRouters.length) > 0 &&
        scrollTopRouters.forEach((route) => {
            if (router.pathname.startsWith(route)) {
                hasRouter = true;
                return;
            }
        });
    if ((scrollTopRouters === null || scrollTopRouters === void 0 ? void 0 : scrollTopRouters.length) > 0 && !hasRouter)
        return null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopWrapper, { showScroll: showScroll, "data-track-content": true, "data-content-region-name": "btnScrollTop", "data-content-name": "btnScrollTop", position: position },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(ScrollToTopBtn, { className: className, onClick: () => scrollTopTop(), backgroundColor: backgroundColor },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_3__/* .SvgIcon */ .l, { name: "up", size: 24, color: color }))));
};




/***/ }),

/***/ 7962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ SearchBar; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24922);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75068);
/* harmony import */ var _contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94265);







const StyledSearchBar = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme, tintColor, barStyle }) => {
    const bgColor = tintColor ? tintColor : theme.colors.gray100;
    const borderRadius = `var(--search-bar-border-radius ,8px)`;
    const styles = {
        display: 'flex',
    };
    switch (barStyle) {
        case 'nav':
            styles['backgroundColor'] = bgColor;
            styles['borderRadius'] = '8px';
            styles['.search-icon'] = {
                backgroundColor: 'transparent',
                order: -1,
            };
            styles['.search-input'] = {
                paddingLeft: 0,
            };
            break;
        case 'light': {
            styles['backgroundColor'] = '#f6f6f6';
            styles['borderRadius'] = '8px';
            styles['.search-icon'] = {
                backgroundColor: 'transparent',
                order: -1,
            };
            styles['.search-input'] = {
                paddingLeft: 0,
            };
            break;
        }
        default:
            styles['backgroundColor'] = bgColor;
            styles.border = `1px solid ${bgColor}`;
            styles.padding = '1px';
            styles['borderRadius'] = borderRadius;
            styles['--button-icon-border-radius'] = borderRadius;
            break;
    }
    return styles;
});
const StyledInput = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Input_Input_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .I) `
  border: 0;
  background-color: transparent;
  flex: 1;
`;
const StyledButtonIcon = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z) `
  height: 36px;
  width: 36px;
  border-radius: 8px;
  padding: 0;
  justify-content: center;
  border: 0;
`;
const SearchBar = (_a) => {
    var { placeholder, prepend, searchIconProps, tintColor, barStyle, className, onClickIcon, onClickInput } = _a, inputProps = (0,tslib__WEBPACK_IMPORTED_MODULE_4__/* .__rest */ ._T)(_a, ["placeholder", "prepend", "searchIconProps", "tintColor", "barStyle", "className", "onClickIcon", "onClickInput"]);
    const theme = (0,_contexts_ThemeProvider_es_js__WEBPACK_IMPORTED_MODULE_5__/* .useTheme */ .F)();
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledSearchBar, { tintColor: tintColor, barStyle: barStyle, className: className },
        prepend,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledInput, Object.assign({ className: "search-input", placeholder: placeholder, onClick: onClickInput, role: "searchbox", "aria-label": "Search" }, inputProps)),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledButtonIcon, Object.assign({ onClick: onClickIcon, className: "search-icon", variant: "primary", "aria-label": "Search", icon: { name: 'search', size: 26, color: theme.colors.white } }, searchIconProps))));
};




/***/ }),

/***/ 61625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PopupRegionPicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87005);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43453);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9958);
/* harmony import */ var components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49308);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69803);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95420);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59802);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98581);








function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 24px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  margin-bottom: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 12px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  z-index: 1060;\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
var PopupRegionPicker = function(param) {
    var showPopup = param.showPopup, selected = param.selected, setSelected = param.setSelected, terminals = param.terminals, locationOptions = param.locationOptions, onClosePopup = param.onClosePopup, onSubmitNewLocation = param.onSubmitNewLocation, activeLocation = param.activeLocation, title = param.title, useDropdownPicker = param.useDropdownPicker;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (terminals === null || terminals === void 0 ? void 0 : terminals.length) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Modal */ .u, {
            size: "sm",
            show: showPopup,
            onHide: function() {
                return onClosePopup();
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_3__/* .ModalHeader */ .x, {
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)('Chọn khu vực sinh sống')
                }),
                !!activeLocation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIcon, {
                    onClick: function() {
                        return onClosePopup();
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .CloseOutlined */ .X, {
                        size: 32,
                        color: "#000000"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .ModalBody */ .f, {
                    children: useDropdownPicker ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    textAlign: 'justify'
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImgWrapper, {
                                src: '/umbala/location.svg',
                                alt: "choose location"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_mobile_organisms_DropDownRegionPicker__WEBPACK_IMPORTED_MODULE_7__/* .DropDownRegionPicker */ .P, {
                                terminals: terminals,
                                onSelectTerminal: setSelected
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledButton, {
                                variant: "primary",
                                size: "m",
                                block: true,
                                onClick: function() {
                                    return onSubmitNewLocation();
                                },
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_4__.t)('X\xe1c nhận')
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledPicker, {
                        options: locationOptions,
                        value: selected,
                        onChange: setSelected,
                        onSubmit: function() {
                            onSubmitNewLocation();
                        },
                        title: title
                    })
                })
            ]
        })
    }));
};
var StyledPicker = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .RegionPicker */ .H)(_templateObject());
var Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .Z.div(_templateObject1());
var ImgWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].img */ .Z.img(_templateObject2());
var StyledButton = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z)(_templateObject3());
var CloseIcon = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div */ .Z.div(_templateObject4());


/***/ }),

/***/ 43189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59802);

var NavigationButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .Z.div(function(param) {
    var theme = param.theme;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 90px;\n  padding: .365rem .75rem;\n  font-size: 13px;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n  color: ".concat(theme.colors.textSecondary, ";\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  &:hover {\n    color: ").concat(theme.colors.primary500, " !important;\n    > :not(.noti) path {\n      fill: ").concat(theme.colors.primary500, ";\n    }\n    > .noti path{\n      stroke: ").concat(theme.colors.primary500, ";\n    }\n    .title, .text-left .title{\n      color: ").concat(theme.colors.primary500, ";\n    }\n    .text-left {\n      text-align: left;\n    }\n  }\n  ");
});


/***/ }),

/***/ 8043:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qY": function() { return /* binding */ convertMegaMenuItem; },
/* harmony export */   "QD": function() { return /* binding */ buildTreeCategories; }
/* harmony export */ });
/* unused harmony export convertUrl */
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40064);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var convertUrl = function(targetPath, urlType, isTargetBlank) {
    if (!targetPath) return;
    if (urlType === 'rewrite') {
        return {
            href: '/search?router=productListing&' + targetPath,
            target: isTargetBlank ? '_blank' : '_self'
        };
    }
    return {
        href: targetPath,
        target: isTargetBlank ? '_blank' : '_self'
    };
};
var convertMegaMenuItem = function(item) {
    var ref, ref1, ref2, ref3;
    return {
        name: item.name,
        icon: item.icon,
        link: (0,_common__WEBPACK_IMPORTED_MODULE_0__/* .computeBlockPageUrl */ .OP)(item) || convertUrl(item.targetPath, item.urlType, item.isTargetBlank),
        banner: !!((ref = item.banners) === null || ref === void 0 ? void 0 : ref.length) ? {
            src: (ref1 = item.banners[0]) === null || ref1 === void 0 ? void 0 : ref1.image,
            hoverEffect: 'zoom',
            link: convertUrl((ref2 = item.banners[0]) === null || ref2 === void 0 ? void 0 : ref2.targetPath, (ref3 = item.banners[0]) === null || ref3 === void 0 ? void 0 : ref3.urlType)
        } : null,
        children: item.children.map(convertMegaMenuItem)
    };
};
var getValidBanners = function(banners) {
    return banners.filter(function(banner) {
        if (!banner.isActive) return false;
        var currentTime = new Date().getTime();
        if ((banner === null || banner === void 0 ? void 0 : banner.startDate) || (banner === null || banner === void 0 ? void 0 : banner.endDate)) {
            if (!(banner === null || banner === void 0 ? void 0 : banner.startDate)) {
                return currentTime <= banner.endDate * 1000;
            }
            if (!(banner === null || banner === void 0 ? void 0 : banner.endDate)) {
                return currentTime >= banner.startDate * 1000;
            }
            return banner.startDate * 1000 <= currentTime && banner.endDate * 1000 >= currentTime;
        }
        return true;
    });
};
var buildTreeCategories = function(menuItems) {
    var rootMenuItems = menuItems.filter(function(param) {
        var parentId = param.parentId;
        return !parentId;
    });
    var buildMenuItem = function(root) {
        var children = menuItems.filter(function(param) {
            var parentId = param.parentId;
            return parentId === root.id;
        });
        return _objectSpread({}, root, {
            banners: getValidBanners(root.banners || []),
            children: children.map(buildMenuItem)
        });
    };
    return rootMenuItems.map(function(root) {
        return buildMenuItem(root);
    });
};


/***/ }),

/***/ 263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "w": function() { return /* binding */ useIdentifiedPage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
var useIdentifiedPage = function(className) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var node = document.createElement('div');
        node.className = className;
        node.style.display = 'none';
        document.body.prepend(node);
        return function() {
            return node.remove();
        };
    }, []);
};


/***/ }),

/***/ 56730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useSearchSuggestions; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47248);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11686);
/* harmony import */ var _useKeyword__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81823);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61047);






function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var useSearchSuggestions = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _numberOfHistories = ref.numberOfHistories, numberOfHistories = _numberOfHistories === void 0 ? 5 : _numberOfHistories, limitKeywords = ref.limitKeywords;
    var isMobile = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useGlobalData */ .U5)().isMobile;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var searchHistoryKey = "".concat(isMobile ? 'MOBILE' : 'DESKTOP', "_SEARCH_HISTORY");
    var initKeyword = lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(router, 'query.query');
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initKeyword), keyword1 = ref1[0], setKeyword = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), histories = ref2[0], setHistories = ref2[1];
    var ref3 = (0,_useKeyword__WEBPACK_IMPORTED_MODULE_4__/* .useKeywords */ .N)(keyword1, limitKeywords), suggestionKeywords = ref3.result;
    var getSearchHistory = function() {
        var count = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 5;
        if (typeof localStorage !== 'undefined') {
            var historyStorage = localStorage.getItem(searchHistoryKey);
            if (historyStorage) {
                var data = JSON.parse(historyStorage);
                return (data || []).reverse().splice(0, count);
            }
            return [];
        }
        return [];
    };
    var saveSearchHistory = function(keyword) {
        var historyStorage = localStorage.getItem(searchHistoryKey);
        if (!historyStorage) {
            localStorage.setItem(searchHistoryKey, JSON.stringify([
                keyword
            ]));
            return;
        }
        var historyArr = JSON.parse(historyStorage);
        historyArr = historyArr.filter(function(item) {
            return JSON.stringify(item) !== JSON.stringify(keyword);
        });
        historyArr = _toConsumableArray(historyArr).concat([
            keyword
        ]);
        localStorage.setItem(searchHistoryKey, JSON.stringify(historyArr));
        setHistories(getSearchHistory(numberOfHistories));
    };
    var removeSearchHistories = function() {
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(searchHistoryKey, JSON.stringify([]));
            setHistories([]);
        }
    };
    var onSearch = function(keywordObj) {
        saveSearchHistory(keywordObj);
        var targetPath = null;
        if (router.query.query) {
            targetPath = {
                pathname: '/search',
                query: _objectSpread({
                    router: 'productListing',
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId
                } : {})
            };
            router.replace(targetPath).then(function() {
                return window.scrollTo(0, 0);
            });
        } else {
            targetPath = {
                pathname: '/search',
                query: _objectSpread({
                    router: 'productListing',
                    query: keywordObj.query
                }, !!keywordObj.categoryId ? {
                    masterCategoryIds: keywordObj.categoryId
                } : {})
            };
            router.push(targetPath).then(function() {
                return window.scrollTo(0, 0);
            });
        }
        var targetUrl = new URL(window.location.origin);
        targetUrl.pathname = targetPath.pathname;
        targetUrl.search = new URLSearchParams(targetPath.query).toString();
        (0,helpers__WEBPACK_IMPORTED_MODULE_5__/* .trackManually */ .gu)('searchButton', 'headerBar', 'searchProductResult', JSON.stringify({
            searchKeyword: keywordObj.query,
            href: window.location.href,
            url: targetUrl.href
        }));
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (numberOfHistories > 0) {
            setHistories(getSearchHistory(numberOfHistories));
        } else setHistories([]);
    }, [
        numberOfHistories
    ]);
    return {
        keyword: keyword1,
        setKeyword: setKeyword,
        histories: histories,
        removeSearchHistories: removeSearchHistories,
        suggestions: suggestionKeywords,
        onSearch: onSearch
    };
};


/***/ }),

/***/ 29229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useUnreadNotification; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11686);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43476);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12354);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84982);




var useUnreadNotification = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var user = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .aC)().user;
    var notificationAppId = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)().notificationAppId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), unreadNotification = ref[0], setUnreadNotification = ref[1];
    var notificationService = (0,_contexts__WEBPACK_IMPORTED_MODULE_4__/* .useServices */ .Su)().notificationService;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var token = localStorage.getItem('fcmToken');
        var unreadParams = {
            app_id: notificationAppId,
            ignore_pending_send: 0,
            token: token !== null && token !== void 0 ? token : undefined
        };
        if (notificationAppId) {
            notificationService.unreadCount(unreadParams).then(function(data) {
                if (data) {
                    setUnreadNotification(data.count);
                }
            });
        }
    }, [
        user === null || user === void 0 ? void 0 : user.userId,
        router,
        notificationAppId
    ]);
    return {
        unreadNotification: unreadNotification
    };
};


/***/ }),

/***/ 4890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ NavigationBar; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(17963);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-2f2a2ef1d7/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(59802);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(61089);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(16251);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Container/Container.es.js
var Container_es = __webpack_require__(56842);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/Row.es.js + 1 modules
var Row_es = __webpack_require__(51296);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Grid/Col.es.js
var Col_es = __webpack_require__(11005);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Divider/Divider.es.js
var Divider_es = __webpack_require__(67386);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/PromoOutlined.es.js
var PromoOutlined_es = __webpack_require__(50659);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/OrderOutlined.es.js
var OrderOutlined_es = __webpack_require__(55327);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/ChecklistOutlined.es.js
var ChecklistOutlined_es = __webpack_require__(9995);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/LocationOutlined.es.js
var LocationOutlined_es = __webpack_require__(69254);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(43476);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-b4cbbda601/0/cache/next-npm-12.0.9-6852d2b6ac-e01e3dbe8b.zip/node_modules/next/router.js
var next_router = __webpack_require__(11686);
// EXTERNAL MODULE: ./helpers/common.ts
var common = __webpack_require__(40064);
// EXTERNAL MODULE: ./hooks/common.ts
var hooks_common = __webpack_require__(263);
;// CONCATENATED MODULE: ./hooks/useLiteMode.tsx




var useLiteMode = function(ssrLiteMode) {
    var navOffsetTop = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(ssrLiteMode), isLite = ref[0], setIsLite = ref[1];
    var ref1 = (0,react.useState)(false), dropdownOpen = ref1[0], setDropdownOpen = ref1[1];
    var listenScrollEvent = function() {
        var scrollOffSetTop = window.pageYOffset || document.documentElement.scrollTop;
        if ((0,common/* isHomepage */.GH)(router.asPath)) {
            if (scrollOffSetTop > navOffsetTop) {
                setIsLite(true);
            } else {
                setIsLite(false);
                setDropdownOpen(false);
            }
        } else {
            setIsLite(true);
        }
    };
    (0,react.useEffect)(function() {
        setDropdownOpen(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener('scroll', listenScrollEvent);
        return function() {
            window.removeEventListener('scroll', listenScrollEvent);
        };
    }, [
        router.asPath,
        navOffsetTop
    ]);
    (0,hooks_common/* useIsomorphicLayoutEffect */.L)(function() {
        setIsLite(!(0,common/* isHomepage */.GH)(router.asPath));
    }, [
        router.asPath
    ]);
    var toggle = (0,react.useCallback)(function() {
        setDropdownOpen(!dropdownOpen);
    }, [
        dropdownOpen
    ]);
    return {
        isLite: isLite,
        dropdownOpen: dropdownOpen,
        toggle: toggle
    };
};

// EXTERNAL MODULE: ./hooks/useRegionPicker.tsx
var useRegionPicker = __webpack_require__(48334);
// EXTERNAL MODULE: ./hooks/useLoyalty.ts
var useLoyalty = __webpack_require__(91277);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/Dropdown/Dropdown.es.js
var Dropdown_es = __webpack_require__(63940);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/organisms/Modal/Modal.es.js
var Modal_es = __webpack_require__(87005);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/organisms/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(43453);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/organisms/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(9958);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/organisms/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(84384);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/Dropdown/DropdownToggle.es.js
var DropdownToggle_es = __webpack_require__(5123);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/Dropdown/DropdownMenu.es.js
var DropdownMenu_es = __webpack_require__(22706);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/ListTile/ListTile.es.js
var ListTile_es = __webpack_require__(62832);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/index.es.js + 6 modules
var dist_index_es = __webpack_require__(84982);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/helpers/tracking.es.js
var tracking_es = __webpack_require__(85727);
// EXTERNAL MODULE: ./components/desktop/organisms/style.ts
var style = __webpack_require__(43189);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Button/Button.es.js + 1 modules
var Button_es = __webpack_require__(98581);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/AccountOutlined.es.js
var AccountOutlined_es = __webpack_require__(14553);
// EXTERNAL MODULE: ./helpers/teko-oauth.ts
var teko_oauth = __webpack_require__(43801);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(12354);
;// CONCATENATED MODULE: ./components/desktop/organisms/UserProfileHeader.tsx












function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 36px;\n  height: 36px;\n  margin: 5px 0 4px 0;\n  &.vertical-avatar {\n    width: 30px;\n    height: 30px;\n    margin: 3px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-radius: 50%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: auto;\n  z-index: 9;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 250px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0.5rem;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 44px;\n  margin-right: 0.5rem;\n  img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  .name {\n    font-size: 1rem;\n    margin-bottom: 0;\n  }\n  .extra {\n    font-size: 0.9rem;\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2rem;\n  width: 100%;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 10px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 100px;\n  height: 36px;\n  padding: 0 20px;\n  margin-left: 8px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 100px;\n  height: 36px;\n  padding: 0 20px;\n  margin-right: 8px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 90px;\n  padding: 0.365rem 0.75rem;\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  :before {\n    content: ' ';\n    width: 30px;\n    height: 30px;\n    border-radius: 15px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n  .title {\n    width: 60px;\n    height: 8px;\n    margin-top: 9px;\n    border-radius: 4px;\n    background: rgb(236, 236, 236);\n    background: linear-gradient(\n      90deg,\n      rgba(236, 236, 236, 1) 0%,\n      rgba(227, 227, 227, 1) 100%\n    );\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
var Avatar = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var AvatarImage = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject1());
var StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(_templateObject2());
var DropdownContent = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());
var BriefUserPanel = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject4());
var UserAvatar = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject5());
var UserInfo = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject6());
var StyledButton = (0,emotion_styled_browser_esm/* default */.Z)(Button_es/* Button */.z)(_templateObject7());
var ButtonWrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject8());
var ModalAction = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject9());
var AcceptButton = (0,emotion_styled_browser_esm/* default */.Z)(Button_es/* Button */.z)(_templateObject10());
var DeclineButton = (0,emotion_styled_browser_esm/* default */.Z)(Button_es/* Button */.z)(_templateObject11());
var SigningButton = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject12());
var ProfileLink = function(param) {
    var icon = param.icon, text = param.text, href = param.href, regionName = param.regionName, contentName = param.contentName, onClick = param.onClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListTile_es/* ListTile */.x, _objectSpread({
            leading: icon,
            title: text,
            numberOfLine: 2,
            onClick: onClick
        }, (0,tracking_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: regionName,
            contentName: contentName
        })))
    }));
};
var UserProfileHeader = function(param) {
    var _vertical = param.vertical, vertical = _vertical === void 0 ? false : _vertical, customProfile = param.customProfile, profileLinks = param.profileLinks;
    if (customProfile) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: customProfile
    }));
    var ref = (0,dist_index_es/* useAuth */.aC)(), userProfile = ref.user, profileLoading = ref.loading, authService = ref.authService;
    var notificationAppId = (0,GlobalDataContext/* useTenantConfig */.Wx)().notificationAppId;
    var notificationService = (0,ServiceContext/* useServices */.Su)().notificationService;
    var ref1 = (0,react.useState)(false), dropdownOpen = ref1[0], setDropdownOpen = ref1[1];
    var ref2 = (0,react.useState)(false), showLogoutConfirmModal = ref2[0], setShowLogoutConfirmModal = ref2[1];
    var toggle = function() {
        return setDropdownOpen(function(prevState) {
            return !prevState;
        });
    };
    var onLogin = function() {
        return authService.login();
    };
    if (profileLoading) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(SigningButton, {
            className: "button",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title"
            })
        }));
    }
    if (!(userProfile === null || userProfile === void 0 ? void 0 : userProfile.userId)) {
        return vertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, _objectSpread({
            className: "button",
            onClick: onLogin,
            style: {
                flexDirection: 'column'
            }
        }, (0,tracking_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: 'headerBar',
            contentName: 'loginIcon'
        }), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                    level: 2,
                    weight: "medium",
                    color: "textSecondary",
                    className: "title",
                    children: (0,i18n.t)('Đăng nhập')
                })
            ]
        })) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, _objectSpread({
            onClick: onLogin
        }, (0,tracking_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: 'headerBar',
            contentName: 'loginIcon'
        }), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-left ml-6",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)('Đăng nhập')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)('Đăng k\xfd')
                        })
                    ]
                })
            ]
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_es/* Modal */.u, {
                show: showLogoutConfirmModal,
                size: "sm",
                onHide: function() {
                    return setShowLogoutConfirmModal(false);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeader_es/* ModalHeader */.x, {
                        children: (0,i18n.t)('Đăng xuất')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalBody_es/* ModalBody */.f, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: (0,i18n.t)('Bạn c\xf3 chắc chắn muốn đăng xuất kh\xf4ng?')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalFooter_es/* ModalFooter */.m, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalAction, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeclineButton, {
                                    variant: "ghost",
                                    onClick: function() {
                                        return setShowLogoutConfirmModal(false);
                                    },
                                    children: (0,i18n.t)('Kh\xf4ng')
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptButton, {
                                    variant: "primary",
                                    onClick: function() {
                                        (0,teko_oauth/* onSignOut */.U3)(authService, notificationService, notificationAppId, window.location.origin);
                                        setShowLogoutConfirmModal(false);
                                    },
                                    children: (0,i18n.t)('C\xf3')
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdown, _objectSpread({
                isOpen: dropdownOpen,
                toggle: toggle,
                toggleType: "hover",
                onHide: function() {
                    return setDropdownOpen(false);
                }
            }, (0,tracking_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: 'headerBar',
                contentName: 'profileIcon'
            }), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            className: vertical ? 'button' : '',
                            style: vertical ? {
                                flexDirection: 'column'
                            } : {
                                flexDirection: 'row'
                            },
                            children: [
                                userProfile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar, {
                                    className: vertical ? 'vertical-avatar' : '',
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AvatarImage, {
                                        src: userProfile.avatar,
                                        "aria-label": "Current User Avatar"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                vertical ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: userProfile.name || userProfile.telephone
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-left ml-12",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)('Xin ch\xe0o,')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: userProfile.name || userProfile.telephone
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                        placement: "bottom",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownContent, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(BriefUserPanel, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UserAvatar, {
                                            children: userProfile.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: userProfile.avatar,
                                                alt: "Avatar"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountOutlined_es/* AccountOutlined */.y, {
                                                size: 36,
                                                color: "textSecondary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserInfo, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "name",
                                                    children: userProfile.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                    className: "extra",
                                                    children: userProfile.email || userProfile.telephone
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                profileLinks && profileLinks.map(function(profileLink) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ProfileLink, {
                                        icon: profileLink.icon,
                                        href: profileLink.href,
                                        text: profileLink.text,
                                        contentName: profileLink.contentName,
                                        regionName: profileLink.regionName,
                                        onClick: function() {
                                            return setDropdownOpen(false);
                                        }
                                    }, profileLink.href);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, _objectSpread({
                                        onClick: function() {
                                            setDropdownOpen(false);
                                            setShowLogoutConfirmModal(true);
                                        },
                                        variant: "primary"
                                    }, (0,tracking_es/* getTrackingData */.O)({
                                        isTrackContent: true,
                                        regionName: 'headerBar',
                                        contentName: 'logOut'
                                    }), {
                                        children: (0,i18n.t)('Đăng xuất')
                                    }))
                                })
                            ]
                        })
                    })
                ]
            }))
        ]
    }));
};

// EXTERNAL MODULE: ./hooks/useUnreadNotification.tsx
var useUnreadNotification = __webpack_require__(29229);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-b4cbbda601/0/cache/next-npm-12.0.9-6852d2b6ac-e01e3dbe8b.zip/node_modules/next/dynamic.js
var dynamic = __webpack_require__(36484);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-c47737ef43/1/packages/ds-foundation/dist/components/Badge/Badge.es.js
var Badge_es = __webpack_require__(35405);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/NotificationsOutlined.es.js
var NotificationsOutlined_es = __webpack_require__(58258);
;// CONCATENATED MODULE: ./components/desktop/organisms/NotificationOverview.tsx










function NotificationOverview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NotificationOverview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NotificationOverview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NotificationOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NotificationOverview_templateObject() {
    var data = NotificationOverview_taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    NotificationOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NotificationOverview_templateObject1() {
    var data = NotificationOverview_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: calc(50% + 12px);\n"
    ]);
    NotificationOverview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var MiniNotification = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 2361).then(__webpack_require__.bind(__webpack_require__, 92361)).then(function(mod) {
        return mod.MiniNotification;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92361)
            ];
        }
    }
});
var NotificationOverview_StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(NotificationOverview_templateObject());
var WrapperBadge = emotion_styled_browser_esm/* default.div */.Z.div(NotificationOverview_templateObject1());
var NotificationOverview = function(param) {
    var _title = param.title, title = _title === void 0 ? false : _title;
    var ref = (0,react.useState)(false), openDropdown = ref[0], setOpenDropdown = ref[1];
    var unreadNotification = (0,useUnreadNotification/* useUnreadNotification */.r)().unreadNotification;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(NotificationOverview_StyledDropdown, NotificationOverview_objectSpread({
        isOpen: openDropdown,
        toggle: function() {
            setOpenDropdown(function(prev) {
                return !prev;
            });
        },
        toggleType: "hover",
        onHide: function() {
            return setOpenDropdown(false);
        }
    }, (0,tracking_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'notificationItem',
        target: 'notification'
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                    className: "button",
                    style: {
                        flexDirection: 'column',
                        minWidth: '68px'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationsOutlined_es/* NotificationsOutlined */.Z, {
                            className: "noti",
                            size: 36,
                            color: "textSecondary"
                        }),
                        !!unreadNotification && unreadNotification > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapperBadge, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_es/* Badge */.C, {
                                count: unreadNotification
                            })
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n.t)('Th\xf4ng b\xe1o')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: 'bottom-end'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniNotification, {
                    onHide: function() {
                        return setOpenDropdown(false);
                    }
                })
            })
        ]
    })));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Cart/CartNumberTracking/CartNumberTracking.es.js
var CartNumberTracking_es = __webpack_require__(29574);
// EXTERNAL MODULE: ../../.yarn/cache/lodash.get-npm-4.4.2-7bda64ed87-e403047ddb.zip/node_modules/lodash.get/index.js
var lodash_get = __webpack_require__(47248);
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);
// EXTERNAL MODULE: ./contexts/CartContext.tsx
var CartContext = __webpack_require__(74721);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers = __webpack_require__(24105);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/helpers/IconBase.es.js + 1 modules
var IconBase_es = __webpack_require__(80711);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/ShoppingCartOutlined.es.js


const ShoppingCartOutlined = (props) => {
    return (0,IconBase_es/* GenIcon */.w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M3 3.75C3 3.33579 3.33579 3 3.75 3H6.00033C6.41455 3 6.75033 3.33579 6.75033 3.75V6.00035H18.7522C18.9832 6.00035 19.2012 6.10676 19.3434 6.28879C19.4855 6.47083 19.5358 6.7082 19.4798 6.93225L17.9796 12.9331C17.8961 13.267 17.5961 13.5012 17.252 13.5012H6.75033V14.2516C6.75033 14.4505 6.82937 14.6413 6.97007 14.782C7.11076 14.9227 7.30158 15.0018 7.50055 15.0018H19.5023C19.9165 15.0018 20.2523 15.3376 20.2523 15.7518C20.2523 16.166 19.9165 16.5018 19.5023 16.5018H7.50055C6.90376 16.5018 6.33141 16.2647 5.90941 15.8427C5.48741 15.4207 5.25033 14.8483 5.25033 14.2516V12.7544C5.25033 12.7534 5.25033 12.7523 5.25033 12.7512C5.25033 12.7502 5.25033 12.7491 5.25033 12.748V6.75355C5.25033 6.75249 5.25033 6.75142 5.25033 6.75035C5.25033 6.74929 5.25033 6.74822 5.25033 6.74715V4.5H3.75C3.33579 4.5 3 4.16421 3 3.75ZM6.75033 7.50035V12.0012H16.6664L17.7916 7.50035H6.75033ZM6.0006 19.5024C6.0006 18.6739 6.67222 18.0023 7.50071 18.0023C8.3292 18.0023 9.00082 18.6739 9.00082 19.5024C9.00082 20.3309 8.3292 21.0025 7.50071 21.0025C6.67222 21.0025 6.0006 20.3309 6.0006 19.5024ZM18.0021 18.0023C17.1736 18.0023 16.502 18.6739 16.502 19.5024C16.502 20.3309 17.1736 21.0025 18.0021 21.0025C18.8306 21.0025 19.5022 20.3309 19.5022 19.5024C19.5022 18.6739 18.8306 18.0023 18.0021 18.0023Z',
                    fill: '#82869E',
                },
            },
        ],
    })(props);
};



;// CONCATENATED MODULE: ./components/desktop/organisms/CartOverview.tsx













function CartOverview_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CartOverview_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CartOverview_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function CartOverview_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CartOverview_templateObject() {
    var data = CartOverview_taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    CartOverview_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CartOverview_templateObject1() {
    var data = CartOverview_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5px;\n  left: calc(50% + 15px);\n"
    ]);
    CartOverview_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var MiniCart = (0,dynamic["default"])(function() {
    return __webpack_require__.e(/* import() */ 9954).then(__webpack_require__.bind(__webpack_require__, 19954)).then(function(mod) {
        return mod.MiniCart;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19954)
            ];
        }
    }
});
var CartOverview_StyledDropdown = (0,emotion_styled_browser_esm/* default */.Z)(Dropdown_es/* Dropdown */.L)(CartOverview_templateObject());
var CartOverview_WrapperBadge = emotion_styled_browser_esm/* default.div */.Z.div(CartOverview_templateObject1());
var CartOverview = function(param) {
    var _vertical = param.vertical, vertical = _vertical === void 0 ? false : _vertical, _showShippingFeeMiniCart = param.showShippingFeeMiniCart, showShippingFeeMiniCart = _showShippingFeeMiniCart === void 0 ? true : _showShippingFeeMiniCart;
    var cart = (0,CartContext/* useCart */.jD)();
    var ref = (0,react.useState)(false), miniCartOpen = ref[0], setMiniCartOpen = ref[1];
    var toggleMiniCart = (0,react.useCallback)(function() {
        setMiniCartOpen(!miniCartOpen);
    }, [
        miniCartOpen
    ]);
    (0,react.useEffect)(function() {
        if (true) {
            if (miniCartOpen) {
                document.body.style.overflow = 'hidden';
                document.body.style.paddingRight = "".concat((0,helpers/* getScrollbarWidth */.npq)(), "px");
            } else {
                document.body.style.overflow = 'unset';
                document.body.style.paddingRight = 'unset';
            }
        }
    }, [
        miniCartOpen
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(CartOverview_StyledDropdown, CartOverview_objectSpread({
        isOpen: miniCartOpen,
        toggle: toggleMiniCart,
        toggleType: "hover",
        onHide: function() {
            return setMiniCartOpen(false);
        }
    }, (0,tracking_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'cartItem',
        target: 'shoppingCart'
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle_es/* DropdownToggle */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                        href: "/cart",
                        children: vertical ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            className: "button",
                            style: {
                                flexDirection: 'column'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                    level: 2,
                                    weight: "medium",
                                    color: "textSecondary",
                                    className: "title",
                                    children: (0,i18n.t)('Giỏ h\xe0ng')
                                }),
                                cart.totalCartItemsSelected > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview_WrapperBadge, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge_es/* Badge */.C, {
                                        count: cart.totalCartItemsSelected
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ShoppingCartOutlined, {
                                    size: 36,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "text-left ml-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)('Giỏ h\xe0ng của bạn')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                            level: 2,
                                            weight: "medium",
                                            color: "textSecondary",
                                            className: "title",
                                            children: (0,i18n.t)('({{cartTotalCartItems}}) sản phẩm', {
                                                cartTotalCartItems: cart.totalCartItemsSelected
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CartNumberTracking_es/* CartNumberTracking */.w, {
                        totalItems: cart.totalCartItemsSelected
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownMenu_es/* DropdownMenu */.h, {
                popperConfig: {
                    placement: 'top-end'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart, {
                    onHide: function() {
                        return setMiniCartOpen(false);
                    },
                    disableProductPromo: lodash_get_default()(cart, 'order.disableProductPromo', false),
                    showShippingFee: showShippingFeeMiniCart
                })
            })
        ]
    })));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/Logo/Logo.es.js
var Logo_es = __webpack_require__(82175);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/MegaMenu/MegaMenu.es.js + 1 modules
var MegaMenu_es = __webpack_require__(12624);
// EXTERNAL MODULE: ./helpers/menuItem.ts
var menuItem = __webpack_require__(8043);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-icon-virtual-b83ad4c2c5/1/packages/ds-icon/dist/components/MenuOutlined.es.js


const MenuOutlined = (props) => {
    return (0,IconBase_es/* GenIcon */.w_)({
        tag: 'svg',
        attr: { viewBox: '0 0 512 512' },
        child: [
            { tag: 'title', attr: {}, child: [] },
            {
                tag: 'line',
                attr: {
                    x1: '88',
                    y1: '152',
                    x2: '424',
                    y2: '152',
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeMiterlimit: '10',
                    strokeWidth: '48px',
                },
            },
            {
                tag: 'line',
                attr: {
                    x1: '88',
                    y1: '256',
                    x2: '424',
                    y2: '256',
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeMiterlimit: '10',
                    strokeWidth: '48px',
                },
            },
            {
                tag: 'line',
                attr: {
                    x1: '88',
                    y1: '360',
                    x2: '424',
                    y2: '360',
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeMiterlimit: '10',
                    strokeWidth: '48px',
                },
            },
        ],
    })(props);
};



;// CONCATENATED MODULE: ./components/desktop/organisms/LogoHeader.tsx











function LogoHeader_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LogoHeader_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LogoHeader_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function LogoHeader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function LogoHeader_templateObject() {
    var data = LogoHeader_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"
    ]);
    LogoHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LogoHeader_templateObject1() {
    var data = LogoHeader_taggedTemplateLiteral([
        "\n  transform: translate(16px, 72px) !important;\n"
    ]);
    LogoHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LogoHeader_templateObject2() {
    var data = LogoHeader_taggedTemplateLiteral([
        "\n  width: 204px;\n  border-radius: 0.5rem;\n"
    ]);
    LogoHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var LogoWrapper = emotion_styled_browser_esm/* default.div */.Z.div(LogoHeader_templateObject());
var StyledLogo = (0,emotion_styled_browser_esm/* default */.Z)(Logo_es/* Logo */.T)(function(param) {
    var lite = param.lite, height = param.height, width = param.width;
    return "\n  height: ".concat(height || 35, "px;\n  ").concat(lite ? 'margin-right: 1rem; margin-left: 0.4rem; padding-right: 1rem;' : '', ";\n  width: ").concat(width ? "".concat(width, "px") : 'auto', " ;\n  -webkit-transition: all .15s ease-in-out;\n  -moz-transition: all .15s ease-in-out;\n  transition: all .15s ease-in-out;\n");
});
var MenuButton = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var theme = param.theme;
    return "\nborder: 1px solid #e0e0e0;\ncursor: pointer;\nborder-radius: 4px;\nline-height: 1rem;\npadding: 0.4rem 0.75rem;\ntext-align: center;\ncolor: ".concat(theme.colors.textSecondary, ";\n&:hover{\n  background: rgb(245, 245, 245);\n}\n");
});
var StyledDropdownMenu = (0,emotion_styled_browser_esm/* default */.Z)(DropdownMenu_es/* DropdownMenu */.h)(LogoHeader_templateObject1());
var MegeMenuWrapper = emotion_styled_browser_esm/* default.div */.Z.div(LogoHeader_templateObject2());
var LogoHeader = function(param) {
    var isLite = param.isLite, dropdownOpen = param.dropdownOpen, toggle = param.toggle, menuItems = param.menuItems;
    var globalData = (0,GlobalDataContext/* useGlobalData */.U5)();
    var logo = (0,GlobalDataContext/* useTenantConfig */.Wx)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(LogoWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, LogoHeader_objectSpread({
                href: "/"
            }, (0,tracking_es/* getTrackingData */.O)({
                isTrackContent: true,
                regionName: 'headerBar',
                contentName: 'logoPhongVu',
                target: 'homepage'
            }), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, {
                    variant: isLite ? 'square' : 'full',
                    lite: isLite,
                    width: logo[isLite ? 'lite' : 'full'].width,
                    height: logo[isLite ? 'lite' : 'full'].height,
                    alt: globalData.tenant,
                    logoFull: logo.full.path,
                    logoLite: logo.lite.path || logo.full.path
                })
            })),
            isLite && !!(menuItems === null || menuItems === void 0 ? void 0 : menuItems.length) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown_es/* Dropdown */.L, {
                isOpen: dropdownOpen,
                toggle: toggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle_es/* DropdownToggle */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuButton, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined, {
                                    size: 20,
                                    color: "textSecondary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        marginLeft: '0.4rem'
                                    },
                                    children: (0,i18n.t)('Danh mục sản phẩm')
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownMenu, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegeMenuWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                menuItems: menuItems.map(menuItem/* convertMegaMenuItem */.qY),
                                type: "vertical"
                            })
                        })
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/molecules/SearchBar/SearchBar.es.js
var SearchBar_es = __webpack_require__(7962);
// EXTERNAL MODULE: ./hooks/useSearchSuggestions.tsx
var useSearchSuggestions = __webpack_require__(56730);
// EXTERNAL MODULE: ./contexts/PopularKeywordContext.tsx
var PopularKeywordContext = __webpack_require__(46951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/mobile/Text/Text.es.js
var Text_es = __webpack_require__(27893);
;// CONCATENATED MODULE: ./components/desktop/organisms/RecommendedKeyword.tsx





function RecommendedKeyword_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function RecommendedKeyword_templateObject() {
    var data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    RecommendedKeyword_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject1() {
    var data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  margin: 8px 0 4px;\n"
    ]);
    RecommendedKeyword_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject2() {
    var data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  padding-top: 4px;\n  display: flex;\n  flex-wrap: wrap;\n  background: #fff;\n"
    ]);
    RecommendedKeyword_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecommendedKeyword_templateObject3() {
    var data = RecommendedKeyword_taggedTemplateLiteral([
        "\n  height: 32px;\n  line-height: 32px;\n  padding: 0 16px;\n  border-radius: 999px;\n  background: #f5f5f5;\n  color: #333;\n  margin: 0 4px 10px 4px;\n  font-size: 14px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #ececec;\n  }\n"
    ]);
    RecommendedKeyword_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledSearchTitle = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject());
var StyledRecommendedKeyword = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject1());
var RecommendedKeywordWrapper = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject2());
var RecommendedKeywordItem = styled_es/* styled.div */.z.div(RecommendedKeyword_templateObject3());
var RecommendedKeyword = function(param) {
    var popularKeywords = param.popularKeywords, onClick = param.onClick;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRecommendedKeyword, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchTitle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                    fontWeight: "500",
                    textTransform: "uppercase",
                    color: "#82869E",
                    children: (0,i18n.t)('Từ kh\xf3a phổ biến')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordWrapper, {
                children: popularKeywords.map(function(term, index) {
                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeywordItem, {
                        "data-track-content": true,
                        "data-content-region-name": "popularKeyword",
                        "data-content-name": term,
                        "data-content-target": "searchProductResult",
                        "data-content-payload": JSON.stringify({
                            screenName: 'searchProduct',
                            index: index
                        }),
                        onClick: function() {
                            return onClick(term);
                        },
                        children: term
                    }, index));
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/SvgIcon/SvgIcon.es.js
var SvgIcon_es = __webpack_require__(28697);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchRecent.tsx





function SearchRecent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchRecent_templateObject() {
    var data = SearchRecent_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 4px 0;\n"
    ]);
    SearchRecent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchRecent_templateObject1() {
    var data = SearchRecent_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchRecent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var SearchRecent_StyledSearchTitle = styled_es/* styled.div */.z.div(SearchRecent_templateObject());
var StyledSearchItem = styled_es/* styled.div */.z.div(function(props) {
    return "\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  background: ".concat(props.selected ? '#f5f5f5' : '#fff', ";\n  border-radius: 8px;\n");
});
var StyledRemoveHistory = styled_es/* styled.div */.z.div(function(props) {
    return "\n  cursor: pointer;\n  color: #848788;\n  &:hover {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n");
});
var StyledCategoryName = styled_es/* styled.div */.z.div(function(props) {
    return "\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n");
});
var StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchRecent_templateObject1());
var SearchRecent = function(param) {
    var histories = param.histories, onRemoveSearchHistories = param.onRemoveSearchHistories, onSearch = param.onSearch, selected = param.selected, onHoverItem = param.onHoverItem;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchRecent_StyledSearchTitle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                        fontWeight: "500",
                        textTransform: "uppercase",
                        color: "#82869E",
                        children: (0,i18n.t)('Lịch sử t\xecm kiếm')
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledRemoveHistory, {
                        onClick: onRemoveSearchHistories,
                        "data-track-content": true,
                        "data-content-region-name": "recentSearch",
                        "data-content-target": "searchProduct",
                        "data-content-name": "clearHistorySearch",
                        children: (0,i18n.t)('X\xf3a lịch sử')
                    })
                ]
            }),
            histories.map(function(history, index) {
                return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSearchItem, {
                    "data-track-content": true,
                    "data-content-region-name": "recentSearch",
                    "data-content-name": history.query,
                    "data-content-target": "searchProductResult",
                    "data-content-payload": JSON.stringify({
                        screenName: 'searchProduct',
                        index: index
                    }),
                    onClick: function() {
                        return onSearch(history);
                    },
                    selected: index === selected,
                    onMouseEnter: function() {
                        return onHoverItem(index);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                            name: "time-outline",
                            size: 20
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            style: {
                                margin: '0 0.6rem'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                    maxLines: 1,
                                    children: history === null || history === void 0 ? void 0 : history.query
                                }),
                                !!(history === null || history === void 0 ? void 0 : history.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCategoryName, {
                                    children: [
                                        "Trong ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "cat-name",
                                            children: history.categoryName
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }, index));
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/desktop/organisms/SearchList.tsx




function SearchList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchList_templateObject() {
    var data = SearchList_taggedTemplateLiteral([
        "\n  min-width: 20px;\n"
    ]);
    SearchList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var SearchList_StyledSearchItem = styled_es/* styled.div */.z.div(function(props) {
    return "\n  display: flex;\n  padding: 0.6rem;\n  cursor: pointer;\n  border-radius: 8px;\n  background: ".concat(props.selected ? '#f5f5f5' : '#fff', ";\n");
});
var SearchList_StyledCategoryName = styled_es/* styled.div */.z.div(function(props) {
    return "\n  color: #82869E;\n  font-size: 13px;\n  .cat-name {\n    color: ".concat(props.theme.brand.primary, ";\n  }\n");
});
var SearchList_StyledIcon = (0,styled_es/* styled */.z)(SvgIcon_es/* SvgIcon */.l)(SearchList_templateObject());
var SearchList = function(param) {
    var suggestions = param.suggestions, onSearch = param.onSearch, onHoverItem = param.onHoverItem, selected = param.selected;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: suggestions.map(function(s, index) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchList_StyledSearchItem, {
                "data-track-content": true,
                "data-content-region-name": "searchSuggestion",
                "data-content-name": s.query,
                "data-content-target": "searchProductResult",
                "data-content-payload": JSON.stringify({
                    screenName: 'searchProduct',
                    index: index
                }),
                onClick: function() {
                    return onSearch(s);
                },
                selected: index === selected,
                onMouseEnter: function() {
                    return onHoverItem(index);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList_StyledIcon, {
                        name: "search",
                        size: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            margin: '0 0.6rem'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text_es/* Text */.x, {
                                maxLines: 1,
                                children: s === null || s === void 0 ? void 0 : s.query
                            }),
                            !!(s === null || s === void 0 ? void 0 : s.categoryId) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchList_StyledCategoryName, {
                                children: [
                                    "Trong ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cat-name",
                                        children: s.categoryName
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index));
        })
    }));
};

// EXTERNAL MODULE: ./constants/local.ts
var local = __webpack_require__(4114);
// EXTERNAL MODULE: ./helpers/tracking.ts
var tracking = __webpack_require__(61047);
;// CONCATENATED MODULE: ./components/desktop/organisms/SearchBar.tsx













function SearchBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SearchBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SearchBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SearchBar_templateObject() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    SearchBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SearchBar_templateObject1() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  border: 1px solid #eaeaea;\n"
    ]);
    SearchBar_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SearchBar_templateObject2() {
    var data = SearchBar_taggedTemplateLiteral([
        "\n  position: absolute;\n  background: #fff;\n  width: 100%;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);\n  padding: 0.5rem 0.8rem;\n  z-index: 1000;\n  display: ",
        ";\n"
    ]);
    SearchBar_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var SearchBarWrapper = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject());
var StyledSearchBar = (0,emotion_styled_browser_esm/* default */.Z)(SearchBar_es/* SearchBar */.E)(SearchBar_templateObject1());
var SearchSuggestion = emotion_styled_browser_esm/* default.div */.Z.div(SearchBar_templateObject2(), function(props) {
    return props.show ? 'block' : 'none';
});
var SearchBar = function() {
    var router = (0,next_router.useRouter)();
    var ref6 = (0,react.useState)(false), visible = ref6[0], setVisible = ref6[1];
    var ref1 = (0,react.useState)(null), selectedSuggestion = ref1[0], setSelectedSuggestion = ref1[1];
    var ref2 = (0,useSearchSuggestions/* useSearchSuggestions */.f)(), keyword = ref2.keyword, setKeyword = ref2.setKeyword, histories = ref2.histories, suggestions = ref2.suggestions, removeSearchHistories = ref2.removeSearchHistories, onSearch = ref2.onSearch;
    var ref3 = (0,PopularKeywordContext/* usePopularKeyword */.y)(), terms = ref3.terms, setStartCallApi = ref3.setStartCallApi;
    var ref4 = (0,react.useState)(keyword || ''), input = ref4[0], setInput = ref4[1];
    var showHistories = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && histories.length > 0;
    var showSuggestions = (keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && suggestions.length > 0;
    var showRecommendedKeywords = !(keyword === null || keyword === void 0 ? void 0 : keyword.trim()) && terms.length > 0;
    var handleSearch = function(keywordObj) {
        onSearch(keywordObj);
        setVisible(false);
    };
    var onKeyUp = function(e) {
        if (e.keyCode === 13) {
            if (!visible || selectedSuggestion === null) {
                !!(input === null || input === void 0 ? void 0 : input.trim()) && handleSearch({
                    query: input.trim()
                });
                return;
            }
            if (showHistories || showSuggestions) {
                var current = showHistories ? histories[selectedSuggestion] : suggestions[selectedSuggestion];
                handleSearch(current);
                return;
            }
        }
    };
    var handleNavigateSearchResult = function(ev) {
        if (visible && (ev.keyCode === local/* ARROW_KEY_UP */.rw || ev.keyCode === local/* ARROW_KEY_DOWN */.sf)) {
            ev.preventDefault();
            if (!showSuggestions && !showHistories) return;
            var currentList = showHistories ? histories : suggestions;
            var length = currentList.length;
            if (selectedSuggestion === null) {
                setSelectedSuggestion(0);
                setInput(currentList[0].query);
            } else {
                if (ev.keyCode === local/* ARROW_KEY_UP */.rw) {
                    if (selectedSuggestion <= 0) {
                        setSelectedSuggestion(length - 1);
                        setInput(currentList[length - 1].query);
                    } else {
                        setSelectedSuggestion(function(prev) {
                            setInput(currentList[prev - 1].query);
                            return prev - 1;
                        });
                    }
                } else if (ev.keyCode === local/* ARROW_KEY_DOWN */.sf) {
                    if (selectedSuggestion >= length - 1) {
                        setSelectedSuggestion(0);
                        setInput(currentList[0].query);
                    } else {
                        setSelectedSuggestion(function(prev) {
                            setInput(currentList[prev + 1].query);
                            return prev + 1;
                        });
                    }
                }
            }
        }
    };
    (0,react.useEffect)(function() {
        var ref, ref5;
        var k = router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref5 = ref.query) === null || ref5 === void 0 ? void 0 : ref5.toString();
        setSelectedSuggestion(null);
        var inputKeyword = k || '';
        setInput(inputKeyword);
        setKeyword(inputKeyword);
    }, [
        router
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchBarWrapper, {
        onMouseLeave: function() {
            return setVisible(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSearchBar, {
                onChange: function(e) {
                    if (!visible) setVisible(true);
                    setSelectedSuggestion(null);
                    setInput(e.target.value);
                    setKeyword(e.target.value);
                },
                onKeyUp: onKeyUp,
                onClickInput: function() {
                    (0,tracking/* trackManually */.gu)('searchBox', 'headerBar', 'searchProduct', JSON.stringify(SearchBar_objectSpread({
                        searchKeyword: input ? input.trim() : ''
                    },  true ? {
                        href: window.location.href,
                        url: window.location.href
                    } : 0)));
                    setVisible(true);
                    setStartCallApi(true);
                },
                value: input,
                placeholder: (0,i18n.t)('Nhập từ kho\xe1 cần t\xecm'),
                onClickIcon: function() {
                    return input && input.trim() && handleSearch({
                        query: input
                    });
                },
                onKeyDown: handleNavigateSearchResult
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchSuggestion, {
                show: visible && (showHistories || showSuggestions || showRecommendedKeywords),
                children: [
                    showHistories && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchRecent, {
                        selected: selectedSuggestion,
                        histories: histories,
                        onRemoveSearchHistories: removeSearchHistories,
                        onSearch: handleSearch,
                        onHoverItem: setSelectedSuggestion
                    }),
                    showSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchList, {
                        suggestions: suggestions,
                        onSearch: handleSearch,
                        onHoverItem: setSelectedSuggestion,
                        selected: selectedSuggestion
                    }),
                    showRecommendedKeywords && /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendedKeyword, {
                        onClick: function(k) {
                            return handleSearch({
                                query: k
                            });
                        },
                        popularKeywords: terms
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./components/desktop/organisms/PopupRegionPicker.tsx
var PopupRegionPicker = __webpack_require__(61625);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-a3f946df97/1/packages/teko-ecommerce/dist/components/Topbar/Topbar.es.js
var Topbar_es = __webpack_require__(36074);
// EXTERNAL MODULE: ./helpers/navigation-bar.tsx + 2 modules
var navigation_bar = __webpack_require__(20321);
;// CONCATENATED MODULE: ./tenants/_template/desktop/_module/components/NavigationBar.tsx














function NavigationBar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavigationBar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavigationBar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function NavigationBar_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function NavigationBar_templateObject() {
    var data = NavigationBar_taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 550;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n"
    ]);
    NavigationBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledNavigationBar = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var lite = param.lite, verticalNavItem = param.verticalNavItem;
    return "\n  @media print {\n    display: none;\n  }\n  background-color: #fff;\n  position: sticky;\n  top: 0;\n  z-index: 1040;\n  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);\n  @media screen and (max-width: 767px) {\n    height: auto !important;\n  }\n\n  ".concat(lite && verticalNavItem ? "\n      min-width: 68px;\n      .title {\n        visibility: hidden;\n        height: 0;\n      }\n      .button {\n        gap: 0;\n      }\n    " : "", "\n");
});
var NavItem = emotion_styled_browser_esm/* default.div */.Z.div(function(param) {
    var theme = param.theme;
    return "\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  cursor: pointer;\n  &:hover {\n    div {\n      color: ".concat(theme.colors.primary500, " !important;\n    }\n    path {\n      fill: ").concat(theme.colors.primary500, " !important;\n    }\n  }\n");
});
var Overlay = emotion_styled_browser_esm/* default.div */.Z.div(NavigationBar_templateObject());
var isVerticalNavItem = function(tenant) {
    switch(tenant){
        case 'phongvu':
            return true;
        case 'ipp':
            return true;
        default:
            return false;
    }
};
var defaultDisplayConfig = {
    order: false,
    promotion: false,
    login: true,
    cart: true,
    additional: undefined
};
var NavigationBar = function(param) {
    var _showShippingFeeMiniCart = param.showShippingFeeMiniCart, showShippingFeeMiniCart = _showShippingFeeMiniCart === void 0 ? true : _showShippingFeeMiniCart, menuItems = param.menuItems, liteLogo = param.liteLogo, displayConfig = param.displayConfig;
    displayConfig = NavigationBar_objectSpread({}, defaultDisplayConfig, displayConfig);
    var ref = (0,react.useState)(0), navOffsetTop = ref[0], setNavOffsetTop = ref[1];
    var ref1 = (0,react.useState)([]), navItems = ref1[0], setNavItems = ref1[1];
    var ref2 = useLiteMode(liteLogo, navOffsetTop), isLite = ref2.isLite, dropdownOpen = ref2.dropdownOpen, toggle = ref2.toggle;
    var ref3 = (0,GlobalDataContext/* useTenantConfig */.Wx)(), partner = ref3.partner, tenant = ref3.tenant, _megaMenuType = ref3.megaMenuType, megaMenuType = _megaMenuType === void 0 ? 'vertical' : _megaMenuType, _alignMegaMenu = ref3.alignMegaMenu, alignMegaMenu = _alignMegaMenu === void 0 ? 'left' : _alignMegaMenu, hideAccountInfo = ref3.hideAccountInfo, notificationAppId = ref3.notificationAppId;
    var regionPickerProps = (0,useRegionPicker/* useRegionPicker */.j)();
    var ref4 = (0,dist_index_es/* useAuth */.aC)(), user = ref4.user, authService = ref4.authService;
    var onLogin = function() {
        return authService.login();
    };
    var router = (0,next_router.useRouter)();
    var region = regionPickerProps === null || regionPickerProps === void 0 ? void 0 : regionPickerProps.activeLocation;
    var loyaltyMemberInfo = (0,useLoyalty/* useLoyalty */.m)().loyaltyMemberInfo;
    var profileLinks = (0,react.useMemo)(function() {
        return (0,navigation_bar/* getNavItems */.r)({
            tenant: tenant,
            logged: !!(user === null || user === void 0 ? void 0 : user.userId),
            isLoyaltyMember: !!loyaltyMemberInfo,
            showNotificationItem: !!notificationAppId
        });
    }, [
        tenant,
        user
    ]);
    var promotionIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
        href: "/khuyen-mai",
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpread({
            className: "button",
            style: isVerticalNavItem(tenant) ? {
                flexDirection: 'column'
            } : {
                flexDirection: 'row'
            }
        }, (0,tracking_es/* getTrackingData */.O)({
            isTrackContent: true,
            regionName: 'headerBar',
            contentName: 'promotionLandingIcon'
        }), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoOutlined_es/* PromoOutlined */.G, {
                    size: 36,
                    color: "textSecondary"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "title",
                    children: (0,i18n.t)('Khuyến m\xe3i')
                })
            ]
        }))
    });
    var orderIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, NavigationBar_objectSpread({
        className: "button",
        onClick: function() {
            if (!(user === null || user === void 0 ? void 0 : user.userId)) {
                onLogin();
            } else {
                router.push('/account/orders');
            }
        },
        style: isVerticalNavItem(tenant) ? {
            flexDirection: 'column'
        } : {
            flexDirection: 'row'
        }
    }, (0,tracking_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'orderIcon'
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderOutlined_es/* OrderOutlined */.y, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "title",
                children: (0,i18n.t)('Đơn h\xe0ng')
            })
        ]
    }));
    var loginIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileHeader, {
        vertical: isVerticalNavItem(tenant),
        customProfile: !!partner ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
            href: "/account/orders",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(style/* NavigationButton */.W, {
                className: "button",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ChecklistOutlined_es/* ChecklistOutlined */.H, {
                        size: 36,
                        color: "textSecondary"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: (0,i18n.t)('Quản l\xfd đơn h\xe0ng')
                    })
                ]
            })
        }) : undefined,
        profileLinks: profileLinks
    });
    var notificationIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationOverview, {
        title: isVerticalNavItem(tenant)
    });
    var cartIcon = /*#__PURE__*/ (0,jsx_runtime.jsx)(CartOverview, {
        showShippingFeeMiniCart: showShippingFeeMiniCart,
        vertical: isVerticalNavItem(tenant)
    });
    var regionPickerIcon = /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavItem, NavigationBar_objectSpread({
        onClick: function() {
            regionPickerProps.onOpenPopup();
        }
    }, (0,tracking_es/* getTrackingData */.O)({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'location'
    }), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOutlined_es/* LocationOutlined */.f, {
                size: 36,
                color: "textSecondary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* Body */.uT, {
                level: 2,
                weight: "medium",
                color: "textSecondary",
                children: [
                    (0,i18n.t)('Khu vực sinh sống'),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    region && region.label
                ]
            })
        ]
    }));
    (0,react.useEffect)(function() {
        var getNavMenuByDisplayConfig = function() {
            var order = displayConfig.order, promotion = displayConfig.promotion, login = displayConfig.login, cart = displayConfig.cart, additional = displayConfig.additional;
            var navMenu = [];
            if (promotion) navMenu.push(promotionIcon);
            if (order) navMenu.push(orderIcon);
            if (login && !hideAccountInfo) navMenu.push(loginIcon);
            if (notificationAppId) navMenu.push(notificationIcon);
            if (cart) navMenu.push(cartIcon);
            if (region) navMenu.push(regionPickerIcon);
            if (additional) navMenu.push(additional);
            return navMenu;
        };
        setNavItems(getNavMenuByDisplayConfig());
    }, [
        user === null || user === void 0 ? void 0 : user.userId
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            dropdownOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledNavigationBar, {
                lite: isLite,
                verticalNavItem: isVerticalNavItem(tenant),
                id: "mainNavigationBar",
                ref: function(navRef) {
                    if (navRef) {
                        var scrollTop = document.documentElement.scrollTop;
                        setNavOffsetTop(scrollTop % Topbar_es/* TOPBAR_HEIGHT */.n);
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row_es/* Row */.X, {
                            gutter: [
                                16,
                                16
                            ],
                            align: "middle",
                            style: megaMenuType === 'vertical' && isVerticalNavItem(tenant) && isLite ? {
                                height: '72px'
                            } : {
                                height: '88px'
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoHeader, {
                                        isLite: megaMenuType === 'vertical' && ( true ? isLite : 0),
                                        dropdownOpen: dropdownOpen,
                                        toggle: toggle,
                                        // Only show mega menu dropdown on type vertical
                                        menuItems: megaMenuType === 'vertical' ? menuItems : []
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                    flex: "auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchBar, {})
                                }),
                                navItems.map(function(item, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        children: item
                                    }, index);
                                })
                            ]
                        })
                    }),
                    megaMenuType === 'horizontal' && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider_es/* Divider */.i, {
                                gap: 0,
                                color: "divider"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container_es/* Container */.W, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row_es/* Row */.X, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col_es/* Col */.JX, {
                                        span: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MegaMenu_es/* MegaMenu */.V, {
                                            type: "horizontal",
                                            align: alignMegaMenu,
                                            menuItems: menuItems.map(menuItem/* convertMegaMenuItem */.qY)
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopupRegionPicker/* PopupRegionPicker */.H, NavigationBar_objectSpread({}, regionPickerProps))
        ]
    }));
};


/***/ }),

/***/ 67085:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 84019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v2": function() { return /* reexport */ Alignment; },
  "hT": function() { return /* reexport */ DSSize; },
  "fd": function() { return /* reexport */ DividerStyleEnum; }
});

// UNUSED EXPORTS: DividerTypeEnum, Variant, VerticalAlignment

;// CONCATENATED MODULE: ../../packages/types/dist/shared/enum.es.js
var Variant;
(function (Variant) {
    Variant["primary"] = "primary";
    Variant["secondary"] = "secondary";
    Variant["ghost"] = "ghost";
    Variant["link"] = "link";
})(Variant || (Variant = {}));
var Alignment;
(function (Alignment) {
    Alignment["left"] = "left";
    Alignment["center"] = "center";
    Alignment["right"] = "right";
    Alignment["justify"] = "justify";
})(Alignment || (Alignment = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["top"] = "top";
    VerticalAlignment["center"] = "center";
    VerticalAlignment["bottom"] = "bottom";
})(VerticalAlignment || (VerticalAlignment = {}));
var DSSize;
(function (DSSize) {
    DSSize["small"] = "small";
    DSSize["default"] = "default";
    DSSize["large"] = "large";
})(DSSize || (DSSize = {}));
var DividerTypeEnum;
(function (DividerTypeEnum) {
    DividerTypeEnum["text"] = "text";
    DividerTypeEnum["icon"] = "icon";
})(DividerTypeEnum || (DividerTypeEnum = {}));
var DividerStyleEnum;
(function (DividerStyleEnum) {
    DividerStyleEnum["solid"] = "solid";
    DividerStyleEnum["double"] = "double";
    DividerStyleEnum["dotted"] = "dotted";
    DividerStyleEnum["dashed"] = "dashed";
})(DividerStyleEnum || (DividerStyleEnum = {}));



;// CONCATENATED MODULE: ../../packages/types/dist/shared/index.es.js



/***/ })

}]);